import React from 'react';

// Arabic translations (العربية)
export const arabicTranslations = {
  // ========== التنقل والتخطيط ==========
  title: "دواليتي - منصة بطولات الألعاب",
  welcome: "مرحباً",
  points: "نقاط",
  logout: "تسجيل الخروج",
  tournaments: "البطولات",
  pointsProfile: "النقاط والملف الشخصي",
  matchHistory: "سجل المباريات",
  adminPanel: "لوحة الإدارة",
  approverPanel: "لوحة المصادقين",
  supervisorPanel: "لوحة المشرفين",
  managerPanel: "لوحة المدير",
  login: "تسجيل الدخول",
  register: "سجل هنا",
  myProfile: "ملفي الشخصي",
  dontHaveAccount: "ليس لديك حساب؟",
  language: "اللغة",
  liveChat: "الدردشة المباشرة",
  menu: "القائمة",
  publicProfile: "عام",
  levelsBadges: "المستوى والتقدم",

  // ========== المصادقة ==========
  username: "اسم المستخدم",
  password: "كلمة المرور",
  email: "البريد الإلكتروني",
  inGameName: "الاسم داخل اللعبة",
  backToLogin: "العودة لتسجيل الدخول",
  createAccount: "إنشاء حساب",
  loginSuccessful: "تم تسجيل الدخول بنجاح!",
  welcomeBattlefield: "مرحباً بك في ساحة المعركة!",
  registrationSuccessful: "تم التسجيل بنجاح!",
  logoutSuccessful: "تم تسجيل الخروج بنجاح",
  loggingIn: "جارٍ تسجيل الدخول...",
  creatingAccount: "جارٍ إنشاء الحساب...",

  // ========== التحقق من الحقول ==========
  loginSubtitle: "تسجيل الدخول إلى حسابك",
  fillAllFields: "املأ جميع الحقول لإنشاء حسابك",
  enterUsername: "أدخل اسم المستخدم",
  enterPassword: "أدخل كلمة المرور",
  enterEmail: "أدخل بريدك الإلكتروني",
  enterInGameName: "Enter your in-game name",
  reenterPassword: "أعد إدخال كلمة المرور",
  confirmPassword: "تأكيد كلمة المرور",

  // أخطاء التحقق
  usernameRequired: "اسم المستخدم مطلوب",
  usernameTooShort: "يجب أن يحتوي اسم المستخدم على 3 أحرف على الأقل",
  usernameTooLong: "يجب أن يكون اسم المستخدم أقل من 20 حرفًا",
  usernameNoHebrew: "لا يمكن أن يحتوي اسم المستخدم على أحرف عبرية",
  usernameNoArabic: "لا يمكن أن يحتوي اسم المستخدم على أحرف عربية",
  usernameInvalidChars: "يمكن أن يحتوي اسم المستخدم فقط على أحرف وأرقام وشرطة سفلية وشرطة",
  emailRequired: "البريد الإلكتروني مطلوب",
  emailInvalid: "الرجاء إدخال بريد إلكتروني صالح",
  inGameNameRequired: "الاسم داخل اللعبة مطلوب",
  inGameNameTooShort: "يجب أن يحتوي الاسم داخل اللعبة على حرفين على الأقل",
  inGameNameTooLong: "يجب أن يكون الاسم داخل اللعبة أقل من 30 حرفًا",
  passwordRequired: "كلمة المرور مطلوبة",
  passwordTooShort: "يجب أن تحتوي كلمة المرور على 6 أحرف على الأقل",
  passwordTooLong: "يجب أن تكون كلمة المرور أقل من 50 حرفًا",
  passwordNeedsNumber: "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل",
  passwordNeedsLetter: "يجب أن تحتوي كلمة المرور على حرف واحد على الأقل",
  confirmPasswordRequired: "الرجاء تأكيد كلمة المرور",
  passwordsDoNotMatch: "كلمات المرور غير متطابقة",

  // نجاح التحقق
  usernameValid: "اسم المستخدم صالح",
  emailValid: "البريد الإلكتروني صالح",
  inGameNameValid: "الاسم داخل اللعبة صالح",
  passwordValid: "كلمة المرور صالحة",
  passwordsMatch: "كلمات المرور متطابقة",

  // متطلبات كلمة المرور
  min6Chars: "6 أحرف على الأقل",
  hasLetter: "يحتوي على حرف",
  hasNumber: "يحتوي على رقم",

  // أخطاء تسجيل الدخول
  invalidCredentials: "اسم المستخدم أو كلمة المرور غير صحيحة",
  userNotFound: "المستخدم غير موجود. تحقق من اسم المستخدم.",
  wrongPassword: "كلمة المرور غير صحيحة. حاول مرة أخرى.",
  accountDisabled: "تم تعطيل حسابك. اتصل بالدعم.",
  loginFailed: "فشل تسجيل الدخول. حاول مرة أخرى.",
  registrationFailed: "فشل التسجيل. حاول مرة أخرى.",

// ========== استرداد كلمة المرور ==========  forgotPassword: "نسيت كلمة المرور؟",  forgotPasswordTitle: "نسيت كلمة المرور",  forgotPasswordSubtitle: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",  sendResetLink: "إرسال رابط إعادة التعيين",  sending: "جاري الإرسال...",  checkYourEmail: "تحقق من بريدك الإلكتروني",  resetLinkSent: "إذا كان هناك حساب بهذا البريد الإلكتروني، ستتلقى رابط إعادة تعيين كلمة المرور قريبًا. يرجى التحقق من مجلد البريد العشوائي أيضًا.",  linkExpiresIn: "سينتهي صلاحية الرابط خلال ساعة واحدة.",  resetPassword: "إعادة تعيين كلمة المرور",  resetPasswordTitle: "إعادة تعيين كلمة المرور",  resetPasswordSubtitle: "أدخل كلمة المرور الجديدة أدناه.",  newPassword: "كلمة المرور الجديدة",  confirmNewPassword: "تأكيد كلمة المرور",  enterNewPassword: "أدخل كلمة المرور الجديدة",  confirmNewPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",  resetting: "جاري إعادة التعيين...",  passwordResetSuccess: "تم إعادة تعيين كلمة المرور!",  passwordResetSuccessMessage: "تم إعادة تعيين كلمة المرور بنجاح.",  redirectingToLogin: "جاري التحويل إلى صفحة تسجيل الدخول...",  loginNow: "تسجيل الدخول الآن",  invalidResetLink: "رابط غير صالح",  invalidResetLinkMessage: "رابط إعادة تعيين كلمة المرور هذا غير صالح أو منتهي الصلاحية.",  resetLinkExpiredNote: "تنتهي صلاحية روابط إعادة التعيين بعد ساعة واحدة لأسباب أمنية.",  requestNewResetLink: "طلب رابط إعادة تعيين جديد",  verifyingResetLink: "جاري التحقق من رابط إعادة التعيين...",
  
  // ========== PASSWORD RECOVERY ==========
  forgotPassword: "نسيت كلمة المرور؟",
  forgotPasswordTitle: "نسيت كلمة المرور",
  forgotPasswordSubtitle: "أدخل عنوان بريدك الإلكتروني وسنرسل لك رابطًا لإعادة تعيين كلمة المرور.",
  sendResetLink: "إرسال رابط إعادة التعيين",
  sending: "جاري الإرسال...",
  checkYourEmail: "تحقق من بريدك الإلكتروني",
  resetLinkSent: "إذا كان هناك حساب بهذا البريد الإلكتروني، ستتلقى رابط إعادة تعيين كلمة المرور قريبًا. يرجى التحقق من مجلد البريد العشوائي أيضًا.",
  linkExpiresIn: "سينتهي صلاحية الرابط خلال ساعة واحدة.",
  resetPassword: "إعادة تعيين كلمة المرور",
  resetPasswordTitle: "إعادة تعيين كلمة المرور",
  resetPasswordSubtitle: "أدخل كلمة المرور الجديدة أدناه.",
  newPassword: "كلمة المرور الجديدة",
  confirmNewPassword: "تأكيد كلمة المرور",
  enterNewPassword: "أدخل كلمة المرور الجديدة",
  confirmNewPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",
  resetting: "جاري إعادة التعيين...",
  passwordResetSuccess: "تم إعادة تعيين كلمة المرور!",
  passwordResetSuccessMessage: "تم إعادة تعيين كلمة المرور بنجاح.",
  redirectingToLogin: "جاري التحويل إلى صفحة تسجيل الدخول...",
  loginNow: "تسجيل الدخول الآن",
  invalidResetLink: "رابط غير صالح",
  invalidResetLinkMessage: "رابط إعادة تعيين كلمة المرور هذا غير صالح أو منتهي الصلاحية.",
  resetLinkExpiredNote: "تنتهي صلاحية روابط إعادة التعيين بعد ساعة واحدة لأسباب أمنية.",
  requestNewResetLink: "طلب رابط إعادة تعيين جديد",
  verifyingResetLink: "جاري التحقق من رابط إعادة التعيين...",

// ========== نظام المستويات الأساسي ==========
  level: "المستوى",
  levels: "المستويات",
  experience: "الخبرة",
  exp: "خبرة",
  totalExp: "إجمالي الخبرة",
  expNeeded: "الخبرة المطلوبة",
  expToNext: "الخبرة للمستوى التالي",
  expGained: "الخبرة المكتسبة",
  expReward: "مكافأة الخبرة",
  currentLevel: "المستوى الحالي",
  nextLevel: "المستوى التالي",
  maxLevel: "أعلى مستوى!",
  levelUp: "ترقية المستوى!",
  levelProgress: "تقدم المستوى",
  levelSystem: "نظام المستويات",
  loadingLevel: "جارٍ تحميل المستوى...",
  levelTooltip: "المستوى {level} - {title}\n{totalExp} إجمالي الخبرة\n{remaining}",

  // ========== ألقاب المستويات ==========
  beginner: "مبتدئ",
  novice: "متدرب",
  intermediate: "متوسط",
  advanced: "متقدم",
  professional: "محترف",
  expert: "خبير",
  master: "أستاذ",
  grandmaster: "أستاذ كبير",
  mythic: "أسطوري",
  sage: "حكيم",
  legend: "أسطورة",

  // ========== نظام الشارات ==========
  badges: "الشارات",
  badge: "شارة",
  earnedBadges: "المكتسبة",
  inProgress: "قيد التقدم",
  allBadges: "الكل",
  loadingBadges: "جارٍ تحميل الشارات...",
  noBadges: "لا توجد شارات بعد",
  badgeUnlocked: "تم فتح الشارة!",
  badgeProgress: "تقدم الشارة",
  badgeModal: "تفاصيل الشارة",
  comingSoon: "قريباً",
  systemLoading: "جارٍ تحميل النظام...",
  noBadgesYet: "لا توجد شارات بعد",
  characterCount: "{count}/1000",
  progressPercentage: "{percentage}% مكتمل",
  currentProgress: "التقدم الحالي",

  // ========== فئات الشارات ==========
  allCategories: "جميع الفئات",
  winStreak: "سلسلة الانتصارات",
  filler: "ملء",
  totalWins: "إجمالي الانتصارات",
  pointsWinning: "نقاط الفوز",
  pointsPurchase: "شراء النقاط",
  multiplayer: "متعدد اللاعبين",
  battleRoyale: "باتل رويال",
  multiplayerWins: "انتصارات متعدد اللاعبين",
  battleRoyaleWins: "انتصارات باتل رويال",

  // ========== ندرة الشارات ==========
  common: "عادي",
  rare: "نادر",
  epic: "ملحمي",
  legendary: "أسطوري",

  // ========== نافذة الشارة ==========
  close: "إغلاق",
  category: "الفئة",
  requirement: "المتطلب",
  unlocked: "مفتوح",
  unlockedOn: "تم الفتح في",
  progress: "التقدم",
  remaining: "متبقي",
  tip: "نصيحة",
  gotIt: "فهمت!",

  // ========== مؤشرات التقدم ==========
  complete: "مكتمل",
  completion: "الإكمال",
  showMore: "عرض المزيد",
  showLess: "عرض أقل",
  upcoming: "قادم",
  upcomingMilestones: "المعالم القادمة",
  congratsMaxLevel: "تهانينا! لقد وصلت إلى أعلى مستوى!",
  totalExpEarned: "إجمالي الخبرة المكتسبة",
  progressDetails: "تفاصيل التقدم",
  expForCurrentLevel: "الخبرة للمستوى الحالي",
  expForNextLevel: "الخبرة للمستوى التالي",
  progressToNext: "التقدم للمستوى التالي",

  // ========== مؤشرات الحالة ==========
  loading: "جارٍ التحميل...",
  loadingProgress: "جارٍ تحميل التقدم...",
  offline: "غير متصل",
  online: "متصل",

  // ========== نصائح الشارات ==========
  winStreakTip: "استمر في الفوز بالمباريات المتتالية للوصول إلى هذا الهدف! تحتاج {remaining} انتصارات متتالية إضافية.",
  totalWinsTip: "اربح المزيد من البطولات لفتح هذه الشارة. {remaining} انتصارات متبقية!",
  pointsWinningTip: "اكسب المزيد من النقاط من الفوز بالبطولات. تحتاج {remaining} نقطة إضافية.",
  pointsPurchaseTip: "اشترِ المزيد من النقاط لفتح هذه الشارة. {remaining} نقطة متبقية للشراء.",
  fillerTip: "أضف لاعبين تلقائيين إلى البطولات وأتمنى لهم الفوز! {remaining} انتصارات تلقائية إضافية مطلوبة.",
  multiplayerTip: "العب المزيد من بطولات متعدد اللاعبين. {remaining} مباراة متبقية.",
  battleRoyaleTip: "شارك في المزيد من مباريات باتل رويال. {remaining} مباراة متبقية.",
  multiplayerWinsTip: "اربح المزيد من بطولات متعدد اللاعبين. {remaining} انتصارات مطلوبة.",
  battleRoyaleWinsTip: "اربح المزيد من مباريات باتل رويال. {remaining} انتصارات للفتح.",
  genericTip: "استمر في اللعب لفتح هذه الشارة! {remaining} متبقية.",

  // ========== إشعارات الترقية ==========
  levelUpNotification: "ترقية المستوى!",
  levelUpTitle: "تهانينا!",
  levelUpSubtitle: "لقد وصلت إلى مستوى جديد!",
  newLevelUnlocked: "تم فتح مستوى جديد",
  titleEarned: "تم الحصول على اللقب",

  // ========== الإحصائيات ==========
  statistics: "الإحصائيات",
  totalEarned: "إجمالي المكتسب",
  totalAvailable: "إجمالي المتاح",
  completionPercentage: "نسبة الإكمال",
  earnedCount: "العدد المكتسب",
  progressCount: "العدد قيد التقدم",

  // ========== رسائل الإنجازات ==========
  achievementUnlocked: "تم فتح الإنجاز!",
  newBadgeEarned: "تم الحصول على شارة جديدة!",
  levelMilestone: "معلم المستوى!",
  experienceGained: "الخبرة المكتسبة: +{amount}",

  // ========== رسائل الخطأ ==========
  failedToLoadBadges: "فشل في تحميل الشارات",
  failedToLoadLevel: "فشل في تحميل المستوى",
  failedToLoadProgress: "فشل في تحميل التقدم",

  // ========== أزرار الإجراءات ==========
  viewDetails: "عرض التفاصيل",
  trackProgress: "تتبع التقدم",
  shareAchievement: "مشاركة الإنجاز",

  // ========== الإشعارات ==========
  badgeEarned: "تم الحصول على الشارة: {badgeName}",
  levelIncreased: "ترقية المستوى! الآن مستوى {level}",
  milestoneReached: "تم الوصول إلى المعلم!",

  // ========== العروض المختصرة ==========
  lvl: "مستوى",
  expShort: "خبرة",
  badgesShort: "شارات",

  // ========== أشرطة التقدم ==========
  progressBarLabel: "التقدم: {current}/{total}",
  completionRate: "معدل الإكمال: {percentage}%",

  // ========== الوقت ==========
  recentlyUnlocked: "تم فتحه مؤخراً",
  timeToUnlock: "الوقت للفتح",
  earnedToday: "مكتسب اليوم",
  earnedThisWeek: "مكتسب هذا الأسبوع",

  // ========== الفلاتر والترتيب ==========
  filterByCategory: "تصفية حسب الفئة",
  sortByProgress: "ترتيب حسب التقدم",
  sortByRarity: "ترتيب حسب الندرة",
  sortByDate: "ترتيب حسب التاريخ",

  // ========== نص المساعدة ==========
  howToEarnBadges: "كيفية كسب الشارات",
  levelSystemExplanation: "شرح نظام المستويات",
  experienceExplanation: "شرح نقاط الخبرة",

  // ========== الأحداث الخاصة ==========
  specialEvent: "حدث خاص",
  limitedTime: "وقت محدود",
  eventBadge: "شارة الحدث",
  seasonalBadge: "شارة موسمية",

  // ========== ترجمات الملف الشخصي العام ==========
  profileTitle: "ملف {name}",
  playerNotFound: "اللاعب غير موجود",
  profilePrivate: "هذا الملف خاص",
  failedToLoadProfile: "فشل في تحميل الملف الشخصي",
  playerNotFoundDesc: "اللاعب الذي تبحث عنه غير موجود أو تم حظره.",
  profilePrivateDesc: "هذا اللاعب جعل ملفه الشخصي خاصاً.",
  profileLoadError: "حدث خطأ أثناء تحميل الملف الشخصي. يرجى المحاولة مرة أخرى.",
  yourProfile: "ملفك الشخصي",
  searchOtherPlayer: "البحث عن لاعب آخر",
  findPlayer: "البحث عن لاعب",
  searchPlayerDesc: "ابحث عن أي لاعب باسم المستخدم أو الاسم داخل اللعبة لعرض ملفه العام.",
  loadingProfile: "جارٍ تحميل الملف...",
  loadingPlayerProfile: "جارٍ تحميل ملف اللاعب...",
  playerProfiles: "ملفات اللاعبين",

  // ========== ترجمات لوحة المتصدرين ==========
  wins: "الانتصارات",
  avgPrize: "المتوسط",
  totalPrize: "إجمالي الجوائز",
  losses: "الخسائر",
  leaderboard: "لوحة المتصدرين",
  levelLeaderboard: "ترتيب المستويات",
  winsLeaderboard: "ترتيب الانتصارات",
  winStreakLeaderboard: "ترتيب سلسلة الانتصارات",
  pointsLeaderboard: "ترتيب النقاط",
  levelLeaderboardDesc: "أفضل اللاعبين مرتبين حسب نقاط الخبرة والمستوى",
  winsLeaderboardDesc: "أفضل اللاعبين مرتبين حسب إجمالي انتصارات البطولات",
  winStreakLeaderboardDesc: "أفضل اللاعبين بسلسلات الانتصارات الحالية",
  pointsLeaderboardDesc: "أفضل اللاعبين مرتبين حسب رصيد النقاط الحالي",
  loadingLeaderboard: "جارٍ تحميل لوحة المتصدرين...",
  loadingRankings: "جارٍ تحميل تصنيفات اللاعبين...",
  failedToLoadLeaderboard: "فشل في تحميل لوحة المتصدرين",
  leaderboardRefreshed: "تم تحديث لوحة المتصدرين!",
  leaderboardLoadError: "حدث خطأ أثناء تحميل لوحة المتصدرين. يرجى المحاولة مرة أخرى.",
  noDataAvailable: "لا توجد بيانات متاحة",
  noActiveStreaks: "لا يوجد لاعبون لديهم سلسلات انتصارات نشطة حالياً.",
  noPlayersFound: "لم يتم العثور على لاعبين لهذه اللوحة.",
  fullRankings: "التصنيفات الكاملة",
  champion: "البطل",
  currentStreak: "السلسلة الحالية",
  maxStreak: "الأقصى",
  levelDesc: "حسب الخبرة",
  winsDesc: "حسب الانتصارات",
  winStreakDesc: "السلسلات الحالية",
  pointsDesc: "حسب الرصيد",
  lastUpdated: "آخر تحديث",
  accountAge: "عمر الحساب",
  days: "أيام",
  you: "(أنت)",
  searchFromLeaderboard: "ابحث عن أي لاعب...",

  // ========== مكونات الملف الشخصي المحسنة ==========
  profile: "الملف الشخصي",
  overview: "نظرة عامة",
  mainAdmin: "المدير الرئيسي",
  supervisor: "مشرف",
  approver: "مصادق",
  manager: "مدير",
  verifiedSponsor: "راعي معتمد",
  player: "لاعب",
  memberSince: "عضو منذ",
  lastSeen: "آخر ظهور",
  currentlyOnline: "حالياً:",
  fillerWins: "انتصارات الملء",
  bestWinStreak: "أفضل سلسلة انتصارات",
  gameModeStats: "إحصائيات أوضاع اللعب",
  accountInformation: "معلومات الحساب",
  funStats: "إحصائيات ممتعة",
  played: "لعب",
  multiplayerWinRate: "معدل فوز متعدد اللاعبين",
  battleRoyaleWinRate: "معدل فوز باتل رويال",

  // ========== البحث والعام ==========
  search: "بحث",
  searchForPlayer: "البحث عن لاعب",
  searchPlayerPlaceholder: "ابحث باسم المستخدم أو الاسم داخل اللعبة...",
  searching: "جارٍ البحث...",
  playersFound: "لاعبين وجدوا",
  noPlayersFoundQuery: "لم يتم العثور على لاعبين يطابقون \"{query}\"",
  searchTipExact: "حاول البحث باسم المستخدم أو الاسم داخل اللعبة بالضبط",
  searchTipUsername: "ابحث باسم المستخدم (مثال: @player123)",
  searchTipInGame: "ابحث بالاسم داخل اللعبة (مثال: ProGamer)",
  searchTip: "استخدم ↑↓ للتنقل، Enter للاختيار، Esc للإغلاق",

  // ========== الشارات والملف الشخصي ==========
  badgeCollection: "مجموعة الشارات",
  earned: "مكتسب",
  categoryBreakdown: "تفصيل الفئات",
  achievementSummary: "ملخص الإنجازات",
  badgeSystemNotAvailable: "نظام الشارات غير متاح لهذا الملف.",
  badgesPrivateDesc: "هذا اللاعب جعل مجموعة شاراته خاصة.",
  badgesLoadError: "حدث خطأ أثناء تحميل مجموعة الشارات.",
  badgeSummaryText: "حصل على {earned} من أصل {total} شارة متاحة ({percentage}% إكمال). فتح {categories} فئات مختلفة وحصل على {exp} نقطة خبرة من الشارات.",
  recentlyEarned: "المكتسبة مؤخراً",
  showProgress: "عرض التقدم",
  categoriesUnlocked: "الفئات",
  totalExpFromBadges: "إجمالي الخبرة من الشارات",

  // ========== سجل المباريات ==========
  noMatches: "لم يتم العثور على مباريات",
  noMatchesDesc: "لم يكمل هذا اللاعب أي مباريات عامة بعد.",
  loadingMatches: "جارٍ تحميل المباريات...",
  total: "الإجمالي",
  prizeWon: "الجائزة المربوحة",
  winRate: "معدل الفوز",
  map: "الخريطة",
  maxKills: "أقصى قتل",
  entry: "الدخول",
  prize: "الجائزة",
  players: "اللاعبون",
  by: "بواسطة",
  won: "فاز",
  lost: "خسر",
  shared: "مشترك",
  thisPlayer: "هذا اللاعب",
  matchSummary: "ملخص المباراة",
  winLossRecord: "سجل الفوز/الخسارة",
  totalPrizeWon: "إجمالي الجوائز المربوحة",
  averagePrize: "متوسط الجائزة لكل فوز",

  // ========== الإحصائيات التفصيلية ==========
  detailedStatistics: "إحصائيات تفصيلية",
  quickStats: "إحصائيات سريعة",
  overallPerformance: "الأداء العام",
  gameModeBreakdown: "تفصيل أوضاع اللعب",
  pointsStatistics: "إحصائيات النقاط",
  specialAchievements: "الإنجازات الخاصة",
  playerSummary: "ملخص اللاعب",
  playerSummaryText: "هو لاعب {performance} مع {wins} انتصارات من أصل {total} مباراة، بمعدل فوز {winRate}%. مصنف حالياً #{rank} عالمياً.",
  currentStreakText: "لديه حالياً سلسلة {streak} انتصارات!",
  bestStreakText: "أفضل سلسلة انتصارات له كانت {streak} انتصارات متتالية.",
  elite: "نخبة",
  pro: "محترف",
  average: "متوسط",
  fillerMaster: "سيد الملء",
  fillerWinsDesc: "فاز ببطولات مع لاعبين تلقائيين",
  streakWarrior: "محارب السلسلة",
  streakDesc: "حقق سلسلات انتصارات مثيرة",
  globalRank: "التصنيف العالمي",
  byExperience: "حسب الخبرة",
  currentPoints: "النقاط الحالية",
  pointsWon: "النقاط المربوحة",
  pointsLost: "النقاط المفقودة",
  netGain: "صافي الربح",
  avgPerWin: "المتوسط لكل فوز",
  fromLosses: "من الخسائر",
  pointsPurchased: "النقاط المشتراة",
  teamBased: "مباريات فريق",
  survivalMode: "وضع البقاء",
  matchesPlayed: "المباريات الملعوبة",
  totalMatches: "إجمالي المباريات",
  badgesEarned: "الشارات المكتسبة",
  badgeExp: "خبرة الشارات",
  categories: "الفئات",

  // ========== الأدوار ==========
  roleChanged: "تم تغيير دورك",
  commissionEarned: "العمولة المكتسبة",
  matchesApproved: "المباريات المصادق عليها",
  approversManaged: "المصادقون المُدارون",
  roleUpdated: "تم تحديث الدور",
  roleChangedTo: "تم تغيير دورك إلى",
  changedBy: "تغيير بواسطة",
  reason: "السبب",
  commissionRates: "معدلات العمولة",

  // ========== ترجمات تنظيف البطولات ==========
  oldTournamentRemoved: 'تم إزالة البطولة القديمة تلقائياً',
  tournamentsAutoRemoved: 'تم إزالة {count} بطولة قديمة من اللوبي',
  pointsRefunded: 'تم إرجاع {amount} نقطة للاعبين',
  adminCleanupActivity: 'التنظيف: تم حذف {deleted} بطولة، تم إرجاع {refunded} نقطة',
  manualCleanupTriggered: 'تنظيف يدوي بواسطة {admin}: حذف {deleted} بطولة',
  autoCleanup: 'تنظيف تلقائي',
  removes: 'يزيل',
  old: 'قديم',
  cleanupNow: 'نظف الآن',
  active: 'نشط',
  stopped: 'متوقف',
  onlyMainAdminCanCleanup: 'فقط المدراء الرئيسيون يمكنهم تشغيل التنظيف اليدوي',
  manualCleanupCompleted: 'اكتمل التنظيف اليدوي: تم إزالة {deleted} بطولة',
  manualCleanupFailed: 'فشل التنظيف اليدوي',
  tournamentAutoDeleted: 'تم حذف البطولة تلقائياً بسبب العمر',
  tournamentDeletedOld: 'تم إزالة البطولة القديمة من اللوبي',
  cleanupServiceActive: 'خدمة التنظيف نشطة',
  cleanupServiceStopped: 'خدمة التنظيف متوقفة',
  tournamentCleanupStatus: 'حالة تنظيف البطولات',
  maxAgeInLobby: 'أقصى عمر في اللوبي',
  cleanupInterval: 'فترة التنظيف',
  lastCleanup: 'آخر تنظيف',
  nextCleanup: 'التنظيف التالي',
  tournamentsProcessed: 'البطولات المعالجة',
  totalRefundedAmount: 'إجمالي المبالغ المستردة',
  cleanupConfiguration: 'إعدادات التنظيف',
  enableAutoCleanup: 'تفعيل التنظيف التلقائي',
  maxAgeHours: 'أقصى عمر (ساعات)',
  intervalMinutes: 'فترة التنظيف (دقائق)',
  maxPerRun: 'أقصى بطولات لكل تشغيل',
  enableNotifications: 'تفعيل الإشعارات',
  saveConfiguration: 'حفظ الإعدادات',
  configurationSaved: 'تم حفظ الإعدادات بنجاح',
  configurationFailed: 'فشل في حفظ الإعدادات',
  triggerManualCleanup: 'تشغيل التنظيف اليدوي',
  cleanupInProgress: 'التنظيف قيد التقدم...',
  cleanupCompleted: 'اكتمل التنظيف',
  noOldTournaments: 'لم يتم العثور على بطولات قديمة',
  cleanupSummary: 'ملخص التنظيف',
  deletedCount: 'محذوف',
  refundedAmount: 'مسترد',
  errors: 'أخطاء',
  duration: 'المدة',
  tournamentAgeWarning: 'سيتم حذف البطولة تلقائياً خلال {time}',
  tournamentAgeInfo: 'عمر البطولة: {age}',
  autoDeleteIn: 'حذف تلقائي خلال',
  minutes: 'دقائق',
  hours: 'ساعات',

  // ========== إدارة الملء ==========
  addFiller: "إضافة ملء",
  fillerManagement: "إدارة الملء",
  fillerPlayers: "لاعبو الملء",
  fillerName: "اسم لاعب الملء",
  enterFillerName: "أدخل اسم الملء...",
  fillerNameRequired: "اسم الملء مطلوب",
  fillerNameTooLong: "اسم الملء طويل جداً (الحد الأقصى 20 حرف)",
  fillerNameHelp: "اختر اسماً فريداً لهذا اللاعب التلقائي (الحد الأقصى 20 حرف)",
  insufficientPointsForFiller: "نقاط غير كافية لإضافة الملء",
  fillerAddedSuccessfully: "تمت إضافة الملء \"{name}\" بنجاح!",
  failedToAddFiller: "فشل في إضافة الملء",
  removeFiller: "إزالة الملء",
  fillerRemoved: "تم إزالة الملء بنجاح!",
  fillerRemovedWithRefund: "تم إزالة الملء! تم إرجاع {amount} نقطة.",
  failedToRemoveFiller: "فشل في إزالة الملء",
  yourFiller: "(ملءك)",
  needMorePoints: "تحتاج {amount} نقطة إضافية",
  needMoreRealPlayers: "تحتاج {count} لاعب حقيقي إضافي قبل إضافة الملء عند امتلاء البطولة",
  needRealPlayersWarning: "تحتاج {count} لاعب حقيقي إضافي لإضافة الملء عند امتلاء البطولة",
  free: "مجاني",
  cost: "التكلفة",
  slots: "المقاعد",
  slotRemaining: "مقعد متبقي",
  slotsRemaining: "مقاعد متبقية",
  giveawayFillerFree: "هذه بطولة هدايا - الملء مجاني!",
  fillerCostWarning: "ستدفع {cost} نقطة لهذا الملء. إذا فاز الملء، ستحصل على الجائزة!",
  fillerAddedAndTournamentUpdated: "تمت إضافة الملء! تم تحديث البطولة.",

  // ========== وظيفة النسخ ==========
  noMatchIdToCopy: "لا يوجد معرف مباراة للنسخ",
  matchIdCopied: "تم نسخ معرف المباراة!",
  noTournamentIdToCopy: "لا يوجد معرف بطولة للنسخ",
  tournamentIdCopied: "تم نسخ معرف البطولة!",

  // ========== البحث والتصفح ==========
  searchFinishedTournaments: "ابحث بمعرف البطولة، المنشئ، وضع اللعب، أو الخريطة...",
  searchResults: "تم العثور على {count} بطولة",
  noSearchResults: "لا توجد نتائج بحث",
  tryDifferentSearch: "جرب مصطلح بحث مختلف أو امسح البحث",
  previousPage: "الصفحة السابقة",
  nextPage: "الصفحة التالية",
  prev: "السابق",
  next: "التالي",
  pageInfo: "صفحة {current} من {total} ({totalItems} إجمالي)",

  // ========== لوحة الإدارة ==========
  mainAdminPanel: "لوحة المدير الرئيسي",
  commissionSummary: "ملخص العمولة",
  yourCommissionEarned: "عمولتك المكتسبة",
  asSupervisor: "(كمشرف)",
  asApprover: "(كمصادق)",
  totalFromUsers: "إجمالي من المستخدمين",
  totalToApprovers: "إجمالي للمصادقين",
  totalToSystem: "إجمالي للنظام",

  // ========== تبويبات الإدارة ==========
  stats: "الإحصائيات",
  roles: "الأدوار",
  pointsTab: "النقاط",
  rates: "المعدلات",
  users: "المستخدمون",
  approvers: "المصادقون",
  inbox: "صندوق الوارد",
  pending: "قيد الانتظار",
  withdrawals: "السحوبات",
  transactionLog: "سجل المعاملات",

  // ========== سجل المعاملات ==========
  totalTransactions: "إجمالي المعاملات",
  pointsIn: "نقاط واردة",
  pointsOut: "نقاط صادرة",
  filters: "الفلاتر",
  hideFilters: "إخفاء",
  showFilters: "عرض",
  transactionType: "النوع",
  searchPlaceholder: "اسم المستخدم أو الوصف...",
  startDate: "تاريخ البداية",
  endDate: "تاريخ النهاية",
  apply: "تطبيق",
  reset: "إعادة تعيين",
  noTransactions: "لم يتم العثور على معاملات",
  transactionsWillAppear: "معاملات النقاط من البطولات والمشتريات وإجراءات الإدارة ستظهر هنا.",

  // ========== إدارة الأدوار ==========
  userRoleManagement: "إدارة أدوار المستخدمين",
  joinDate: 'تاريخ الانضمام',
  totalActiveTime: 'إجمالي النشاط',
  avgDailyTime: 'المعدل اليومي',
  searchUsersModifyRoles: "ابحث عن المستخدمين وعدل أدوارهم في النظام. فقط المدراء الرئيسيون يمكنهم تغيير أدوار المستخدمين.",
  searchUsers: "بحث المستخدمين",
  searchByUsername: "ابحث باسم المستخدم، البريد الإلكتروني، أو الاسم داخل اللعبة...",
  selectedUser: "المستخدم المحدد",
  currentRole: "الدور الحالي",
  newRole: "الدور الجديد",
  roleChangePreview: "تغيير الدور:",
  roleChangeDescription: "تغيير دور المستخدم",
  reasonForChange: "سبب التغيير (اختياري)",
  enterReasonForRoleChange: "أدخل سبب تغيير الدور...",
  changeUserRole: "تغيير دور المستخدم",
  searchAndSelectUser: "ابحث واختر مستخدماً لإدارة دوره",
  rolePermissionsGuide: "دليل صلاحيات الأدوار",
  fullSystemAccess: "وصول كامل للنظام، يمكنه إدارة جميع المستخدمين والإعدادات",
  canManageApprovers: "يمكنه إدارة المصادقين والموافقة على البطولات",
  canApproveTournaments: "يمكنه الموافقة على البطولات وكسب العمولة",
  managerAccess: "صلاحيات المشرف بالإضافة إلى حظر المستخدمين وإدارة الأدوار",
  verifiedSponsorAccess: "يمكنه إنشاء بطولات الهدايا والبطولات متعددة المراحل",
  regularUser: "مستخدم عادي، يمكنه المشاركة في البطولات",
  cannotBeChanged: "⚠️ لا يمكن تغييره",

  // ========== إدارة النقاط ==========
  pointsManagement: "إدارة النقاط",
  searchUsersManagePoints: "ابحث عن المستخدمين وأدر نقاطهم. يمكنك إضافة، إزالة، أو تعيين مبالغ نقاط محددة.",
  actionType: "نوع الإجراء",
  add: "إضافة",
  remove: "إزالة",
  set: "تعيين",
  pointsAmount: "مبلغ النقاط",
  enterPointsAmount: "أدخل مبلغ النقاط...",
  reasonOptional: "السبب (اختياري)",
  enterReasonForPointsAdjustment: "أدخل سبب تعديل النقاط...",
  actionAdd: "إضافة",
  actionRemove: "إزالة",
  actionSet: "تعيين",
  pointsToUser: "نقاط إلى",
  pointsFromUser: "نقاط من",
  pointsForUser: "نقاط لـ",
  newBalance: "الرصيد الجديد:",
  addPoints: "إضافة نقاط",
  removePoints: "إزالة نقاط",
  setPoints: "تعيين نقاط",
  searchAndSelectUserPoints: "ابحث واختر مستخدماً لإدارة نقاطه",

  // ========== إعدادات العمولة ==========
  commissionRateSettings: "إعدادات معدل العمولة",
  multiplayerTournaments: "🎯 بطولات متعدد اللاعبين",
  battleRoyaleTournaments: "👑 بطولات باتل رويال",
  approverCommission: "عمولة المصادق (%)",
  systemCommission: "عمولة النظام (%)",
  updateCommissionRates: "تحديث معدلات العمولة",
  updating: "جارٍ التحديث...",

  // ========== إدارة المستخدمين ==========
  allUsers: "جميع المستخدمين",
  ban: "حظر",
  unban: "إلغاء الحظر",

  // ========== إدارة المصادقين ==========
  addNewApprover: "إضافة مصادق جديد",
  multiplayerCommissionRange: "عمولة متعدد اللاعبين (0-{max}%):",
  battleRoyaleCommissionRange: "عمولة باتل رويال (0-{max}%):",
  addAsApprover: "إضافة كمصادق",
  adding: "جارٍ الإضافة...",
  myApprovers: "مصادقوني",
  noApproversAdded: "لم تتم إضافة مصادقين بعد.",

  // ========== إدارة البطولات ==========
  matchesReadyForApproval: "المباريات جاهزة للموافقة",
  youCanOnlySeeMatches: "ℹ️ يمكنك فقط رؤية المباريات التي لم يطالب بها {role} آخرون أو المباريات التي بدأت الموافقة عليها سابقاً.",
  supervisors: "المشرفون",
  approversLower: "المصادقون",
  noMatchesReady: "لا توجد مباريات جاهزة للموافقة.",
  othersMayHaveClaimed: "{role} آخرون قد يكونون قد طالبوا بالمباريات المتاحة.",
  enterMatchIdFromCod: "أدخل معرف المباراة من كول أوف ديوتي موبايل",
  approve: "موافقة",
  approving: "جارٍ الموافقة...",
  startedBy: "⚠️ بدأ بواسطة:",
  assignedToBot: 'مخصص للبوت',

  // ========== المباريات النشطة ==========
  activeMatches: "المباريات النشطة",
  youCanOnlyManageMatches: "ℹ️ يمكنك فقط رؤية وإدارة المباريات التي وافقت عليها شخصياً.",
  noActiveMatches: "لا توجد مباريات نشطة.",
  haventApprovedMatches: "لم توافق على أي مباريات بعد أو تم إكمالها.",
  roomLabel: "🎮 معرف الغرفة",
  generating: "جارٍ التوليد...",
  noAccess: "🔒 لا وصول",
  notInTournament: "ليس في هذه البطولة",
  copyId: "نسخ المعرف",
  joinRoom: "انضم للغرفة",
  roomUrl: "رابط الغرفة",
  enterRoomUrl: "https://... (رابط اختياري للانضمام للغرفة)",
  roomUrlDescription: "إذا تم توفيره، سيرى اللاعبون زر 'انضم للغرفة'",
  edit: "تعديل",
  cancel: "إلغاء",
  standby: "⏱️ انتظار",
  activeBadge: "🔥 نشط",
  joined: "✓ انضم",
  selectWinners: "اختر الفائز",
  selectWinnersPlural: "اختر الفائزين",
  readyForSelection: "⚡ جاهز للاختيار",
  completeMatch: "إكمال المباراة",
  completing: "جارٍ الإكمال...",
  winner: "فائز",
  winners: "فائزين",
  teamModeInfo: "ℹ️ {mode}: اختر {count} فائز من الفريق الفائز",
  duos: "ثنائيات",
  squads: "فرق",
  teamMode: "فريق",
  winnerSelectionAvailable: "⚡ اختيار الفائز متاح الآن. العد التنازلي هو الموعد النهائي للاعبين للانضمام.",

  // ========== تعديل معرف المباراة ==========
  editMatchId: "تعديل معرف المباراة",
  currentMatchId: "معرف المباراة الحالي:",
  newMatchId: "معرف المباراة الجديد",
  enterNewMatchId: "أدخل معرف المباراة الجديد من كول أوف ديوتي موبايل",
  matchIdCannotBeEmpty: "معرف المباراة لا يمكن أن يكون فارغاً",
  matchIdTooLong: "معرف المباراة يجب أن يكون أقل من 50 حرف",
  sameAsCurrentMatchId: "معرف المباراة الجديد مطابق للحالي",
  validNewMatchId: "✓ معرف مباراة جديد صالح",
  matchIdHistory: "سجل معرف المباراة:",
  current: "(حالي)",
  changingMatchIdNotification: "⚠️ تغيير معرف المباراة سيُخطر جميع المشاركين. تأكد من صحة المعرف الجديد.",
  updateMatchId: "تحديث معرف المباراة",
  updateMatching: "جارٍ التحديث...",

  // ========== إلغاء البطولة ==========
  cancelTournament: "إلغاء البطولة",
  cancellationReason: "سبب الإلغاء",
  enterReasonForCancelling: "أدخل سبب إلغاء هذه البطولة...",
  refundInformation: "⚠️ معلومات الاسترداد:",
  creatorWillReceive: "سيحصل المنشئ على",
  pointsBack: "نقاط مسترجعة",
  eachParticipantWillReceive: "سيحصل كل مشارك على",
  entryFeeBack: "رسوم الدخول مسترجعة",
  totalRefund: "إجمالي الاسترداد",
  giveawayIndicator: "🎁 بطولة هدايا",
  thisActionCannotBeUndone: "⚠️ هذا الإجراء لا يمكن التراجع عنه. سيتم استرداد المبالغ لجميع المشاركين وإلغاء البطولة نهائياً.",
  confirmCancellation: "تأكيد الإلغاء",
  cancelling: "جارٍ الإلغاء...",
  keepTournament: "الإبقاء على البطولة",

  // ========== طلبات السحب ==========
  withdrawalRequests: "طلبات السحب",
  noPendingRequests: "لا توجد طلبات قيد الانتظار.",
  pointsToAmount: "{points} نقطة → ${amount}",

  // ========== نوافذ التأكيد ==========
  confirmRoleChange: "تأكيد تغيير الدور",
  roleChangeFromTo: "{currentRole} → {newRole}",
  thisActionWillImmediately: "⚠️ هذا الإجراء سيغير فوراً دور المستخدم وصلاحياته. سيتم إخطار المستخدم بهذا التغيير.",
  confirmChange: "تأكيد التغيير",
  changingRole: "جارٍ تغيير الدور...",

  // ========== تأكيد النقاط ==========
  confirmPointsAction: "تأكيد {action} النقاط",
  pointsAction: "الإجراء:",
  actionDescription: "{action} {amount} نقطة {preposition} {username}",
  prepositionTo: "إلى",
  prepositionFrom: "من",
  prepositionFor: "لـ",
  thisActionWillUpdatePoints: "⚠️ هذا الإجراء سيحدث فوراً رصيد نقاط المستخدم. تأكد من صحة المبلغ.",
  confirmAction: "تأكيد {action}",
  processing: "جارٍ المعالجة...",

  // ========== التأكيد العام ==========
  changeUserRoleQuestion: "تغيير الدور؟",
  banUserQuestion: "حظر المستخدم؟",
  unbanUserQuestion: "إلغاء حظر المستخدم؟",
  removeApproverQuestion: "إزالة المصادق؟",

  // ========== الإشعارات والرسائل ==========
  roleChangedSuccessfully: "تم تغيير دور {username} إلى {role} بنجاح",
  pointsAddedSuccessfully: "تم إضافة {points} نقطة إلى {username} بنجاح",
  pointsRemovedSuccessfully: "تم إزالة {points} نقطة من {username} بنجاح",
  pointsSetSuccessfully: "تم تعيين {points} نقطة لـ {username} بنجاح",
  matchIdUpdatedSuccessfully: "تم تحديث معرف المباراة بنجاح",
  tournamentCancelledSuccessfully: "تم إلغاء البطولة بنجاح. {refundInfo}",
  commissionRatesUpdated: "تم تحديث معدلات العمولة بنجاح!",
  userBannedSuccessfully: "تم حظر {username} بنجاح!",
  userUnbannedSuccessfully: "تم إلغاء حظر {username} بنجاح!",
  approverAddedSuccessfully: "تم إضافة المصادق بنجاح!",
  approverRemovedSuccessfully: "تم إزالة {username} من دور المصادق بنجاح!",
  matchApprovedSuccessfully: "تم الموافقة على المباراة بنجاح!",
  matchCompletedSuccessfully: "تم إكمال المباراة بنجاح!",
  withdrawalProcessedSuccessfully: "تم معالجة طلب السحب {status} بنجاح!",

  // ========== رسائل الخطأ ==========
  failedToLoadAdminData: "فشل في تحميل بيانات الإدارة",
  failedToChangeUserRole: "فشل في تغيير دور المستخدم",
  failedToManagePoints: "فشل في إدارة النقاط",
  failedToUpdateMatchId: "فشل في تحديث معرف المباراة",
  failedToCancelTournament: "فشل في إلغاء البطولة",
  failedToUpdateCommissionRates: "فشل في تحديث معدلات العمولة",
  failedToProcessWithdrawal: "فشل في معالجة السحب",
  failedToSearchUsers: "فشل في البحث عن المستخدمين",
  invalidUserOrRole: "مستخدم أو دور غير صالح",
  userAlreadyHasRole: "المستخدم لديه هذا الدور بالفعل",
  pleaseSelectUser: "يرجى اختيار مستخدم أولاً",
  pleaseEnterValidAmount: "يرجى إدخال مبلغ نقاط صالح",
  pleaseEnterMatchId: "يرجى إدخال معرف المباراة!",
  pleaseSelectWinner: "يرجى اختيار فائز واحد على الأقل!",
  unknownAction: "إجراء غير معروف: {action}",

  // ========== التسميات والعناصر النائبة ==========
  searchResultsCount: "نتائج البحث ({count})",

  // ========== مؤشرات الحالة ==========
  banned: "محظور",
  approved: "موافق عليه",
  rejected: "مرفوض",

  // ========== إنشاء البطولة ==========
  upTo: 'حتى',
  createTournament: "إنشاء بطولة",
  tournamentType: "نوع البطولة",
  regularTournament: "🏆 بطولة عادية",
  giveawayTournament: "🎁 بطولة هدايا (دخول مجاني)",

  // خيارات مشاركة منشئ الهدايا
  creatorParticipation: "مشاركتك",
  joinAndPlay: "انضم والعب",
  joinAndPlayDesc: "تشارك في المباراة",
  spectateGame: "مشاهدة اللعبة",
  spectateGameDesc: "شاهد المباراة كمتفرج",
  sponsorOnly: "راعي فقط",
  sponsorOnlyDesc: "فقط مول الجائزة، الآخرون يلعبون",
  spectateInfo: "ستكون في اللعبة كمتفرج. يمكنك المشاهدة لكن لا يمكنك اللعب. جميع المقاعد متاحة للآخرين.",
  sponsorInfo: "لن تتم إضافتك للمباراة. جميع المقاعد متاحة للاعبين الآخرين للانضمام بحرية.",
  spectator: "متفرج",

  gameMode: "وضع اللعب",
  multiplayerType: "نوع المباراة",
  battleRoyaleType: "نوع باتل رويال",
  teamMatch: "مباراة فريق",
  customMode: "وضع مخصص",
  solo: "فردي",
  duo: "ثنائي",
  squad: "فريق",
  team: "فريق",
  entryFee: "رسوم الدخول",
  totalPrizePool: "إجمالي الجوائز",
  roomPassword: "كلمة مرور الغرفة",
  optional: "اختياري",
  estimatedPrizePool: "الجوائز المقدرة",
  totalEntryFees: "إجمالي رسوم الدخول",
  commission: "العمولة",
  yourEntryFee: "رسوم دخولك",
  yourTotalCost: "تكلفتك الإجمالية",
  entryFeeForPlayers: "رسوم الدخول للاعبين",
  insufficientPoints: "نقاط غير كافية!",
  createTournamentBtn: "إنشاء البطولة",
  createRegularTournament: "إنشاء بطولة",
  createGiveawayTournament: "إنشاء بطولة هدايا",
  createQuickSolo: "إنشاء فردي سريع",
  creating: "جارٍ الإنشاء...",
  minimize: "تصغير",
  expandChat: "توسيع الدردشة",
  minimizeChat: "تصغير الدردشة",
  closeChat: "إغلاق الدردشة",
  prizePoolForWinners: "الجوائز للفائزين",
  howItWorks: "كيف تعمل",
  howItWorksQuickSolo: "مباراة 1 ضد 1 سريعة على Shipment. أول من يصل إلى {kills} قتيل أو أعلى نتيجة عند {time} يفوز!",
  howItWorksGiveaway: "أنت تدفع {cost} نقطة ({prize} جائزة + {commission} عمولة). اللاعبون ينضمون مجاناً. الفائز(ون) يحصلون على {prizePool} نقطة بالضبط.",
  howItWorksRegular: "إجمالي رسوم الدخول: {totalEntry} نقطة. بعد {commissionRate}% عمولة، الجوائز هي {prizePool} نقطة.",
  locked: "مقفل",

  // ========== فردي سريع ==========
  quickSolo: "⚡ فردي سريع (1v1)",
  quickSoloTournament: "بطولة فردي سريع",
  killLimit: "حد القتل",
  timeLimit: "حد الوقت",
  timeLimitSeconds: "حد الوقت (ثواني)",
  weaponRestrictions: "قيود الأسلحة (اختياري)",
  selectAllowedWeapons: "اختر أنواع الأسلحة المسموحة (اتركها فارغة لجميع الأسلحة)",
  selectedWeapons: "أنواع الأسلحة المختارة",
  allWeaponsAllowed: "جميع الأسلحة مسموحة - لا قيود مطبقة",
  weaponRestrictionsWarning: "⚠️ استخدام الأسلحة المقيدة سيؤدي إلى الاستبعاد الفوري!",
  allowedWeaponsOnly: "هذه الأسلحة فقط مسموحة:",
  quickSoloInfo: "فردي سريع: مباريات 1v1 سريعة على Shipment فقط. مثالي لمعارك النقاط السريعة!",

  // ========== أنواع الأسلحة ==========
  boltActionSniper: "قناص/رامي بولت أكشن",
  shotgun: "شوتغن",
  assault: "هجومي",
  smg: "رشاش خفيف",

  // ========== حالات البطولة ==========
  lobby: "اللوبي",
  wait: "انتظار",
  activeStatus: "نشط",
  finish: "إنهاء",
  deploying: "جارٍ النشر",
  standbyStatus: "انتظار",
  completed: "مكتمل",
  cancelled: "ملغي",
  autoCanceled: "ملغي تلقائياً",

  // ========== إجراءات البطولة ==========
  join: "انضمام",
  abort: "إلغاء",
  copy: "نسخ",
  deploy: "نشر",

  // ========== نافذة انضمام فريق BR ==========
  selectTeamPreference: "اختر تفضيل الفريق",
  selectTeam: "اختر فريقك",
  preference: "التفضيل",
  soloTournament: "بطولة فردية",
  soloTournamentDesc: "تتطلب هذه البطولة أن يلعب جميع اللاعبين بمفردهم. لا يُسمح بفرق.",
  randomTournament: "بطولة فريق مفتوح",
  randomTournamentDesc: "يمكن لأي لاعب الانضمام والتعاون مع الآخرين. اختر تفضيل فريقك أدناه.",
  squadTournament: "بطولة فرقة",
  squadTournamentDesc: "حدد المنشئ أعضاء الفرقة. يمكنك تشكيل فرقتك الخاصة أو الانضمام كعشوائي.",
  teamTournament: "بطولة فريق",
  creatorSquadmates: "أعضاء فرقة المنشئ:",
  duoTeamInfo: "اختر كيف تريد اللعب في بطولة الثنائي هذه",
  squadTeamInfo: "اختر كيف تريد اللعب في بطولة الفرقة هذه",
  yourTeamPreference: "تفضيل فريقك",
  soloTeam: "👤 فردي - بدون زملاء",
  soloLockedReason: "ضبط منشئ البطولة هذا على وضع فردي - يجب على جميع اللاعبين اللعب بمفردهم.",
  randomTeam: "🎲 عشوائي - يمكن لأي لاعب الانضمام",
  squadTeam: "👥 فرقة - اختر زملاء محددين",
  selectSquadmates: "اختر أعضاء الفرقة",
  randomPlayer: "🎲 لاعب عشوائي",
  playerName: "اسم اللاعب",
  specific: "لاعب محدد",
  squadHelpText: "التبديل بين اسم لاعب محدد أو لاعب عشوائي أو مكان فارغ",
  soloInfo: "ستلعب بمفردك. لا يمكن لأحد الانضمام إلى فريقك.",
  randomInfo: "يمكن لأي لاعب متاح الانضمام إلى فريقك.",
  selectTeamToJoin: "اختر الفريق الذي تريد الانضمام إليه. الفرق المميزة بأنها غير متاحة لديها قيود.",
  randomPreference: "تفضيل زميل عشوائي",
  squadPreference: "تفضيل الفرقة",
  noAvailableTeams: "لا توجد فرق متاحة للانضمام. جميع الفرق ممتلئة أو لديها قيود.",
  soloPlayerTeam: "لاعب فردي",
  squadOnly: "فرقة فقط",
  available: "متاح",
  spot: "مكان",
  spots: "أماكن",
  back: "رجوع",

  // ========== تفاصيل البطولة ==========
  giveaway: "هدايا",
  highStakes: "رهانات عالية",
  veryHighStakes: "رهانات عالية جداً",
  legendaryStakes: "رهانات أسطورية",
  passwordProtected: "🔒PWD",
  roomId: "🎮 الغرفة",
  matchLive: "المباراة مباشرة",
  tournamentId: "معرف البطولة",
  copyTournamentId: "نسخ معرف البطولة",

  // ========== اختيار فريق MP ==========
  captainSettings: "إعدادات كابتن الفريق",
  captainSettingsInfo: "بصفتك كابتن الفريق، اختر من يمكنه الانضمام إلى فريقك",
  teamJoinMode: "وضع الانضمام للفريق",
  randomTeammates: "عشوائي - يمكن لأي شخص الانضمام",
  specificTeammates: "محدد - اختر زملاء الفريق",
  selectTeammates: "اختر زملاء الفريق (بالاسم في اللعبة)",
  slot: "خانة",
  clickToEmpty: "انقر للترك فارغاً",
  clickForRandom: "انقر للعشوائي",
  setRandom: "تعيين عشوائي",
  enterInGameName: "أدخل الاسم في اللعبة",
  anyPlayerCanJoin: "يمكن لأي لاعب الانضمام لهذه الخانة",
  teammatesNote: "اترك الخانات فارغة لمنع الآخرين من الانضمام لفريقك",
  randomTeamInfo: "يمكن لأي لاعب الانضمام لفريقك",
  youWillBeCaptain: "ستكون كابتن الفريق",
  youAreInvited: "أنت مدعو لهذا الفريق",
  joiningViaRandomSlot: "الانضمام عبر خانة عشوائية",
  teamNotAccepting: "هذا الفريق لا يقبل لاعبين",
  notOnInviteList: "لست في قائمة الدعوات لهذا الفريق",
  invitedPlayers: "اللاعبون المدعوون:",
  createTeam: "إنشاء فريق",
  mpTeamSelectInfo: "اختر أي فريق للانضمام لهذه المباراة",
  teamRestriction: "قيود الفريق",
  teamSelectionHeading: "اختيار الفريق",
  randomTeam: "فريق عشوائي",
  specificTeam: "فريق محدد",

  // ========== عمليات البطولة ==========
  tournamentOps: "عمليات البطولة",
  intelUpdated: "تم تحديث المعلومات!",
  noActiveLobies: "لا توجد لوبيات نشطة",
  deployFirstTournament: "انشر أول بطولة!",
  noPendingDeployments: "لا توجد عمليات نشر قيد الانتظار",
  fullLobbiesAppear: "اللوبيات الممتلئة ستظهر هنا (إلغاء تلقائي بعد 30 دقيقة)",
  noActiveOperations: "لا توجد عمليات نشطة",
  deployedTournamentsAppear: "البطولات المنشورة ستظهر هنا",
  noCompletedMissions: "لا توجد مهمات مكتملة",
  finishedCancelledAppear: "البطولات المنتهية والملغاة ستظهر هنا",
  noData: "لا توجد بيانات",
  nothingToShow: "لا شيء لعرضه",
  refresh: "تحديث",

  // ========== نظام الدردشة ==========
  chat: "الدردشة",
  searchPlayers: "البحث عن لاعبين...",
  noPlayersOnline: "لا يوجد لاعبون آخرون متصلون",
  noPlayersMatch: "لا يوجد لاعبون يطابقون بحثك",
  sendMessage: "إرسال",
  messageUser: "رسالة",
  typing: "يكتب...",
  connected: "متصل بالخادم!",
  hasUnread: "لديه غير مقروء",
  newMessage: "رسالة جديدة",
  from: "من",
  in: "في",

  // ========== النقاط والملف الشخصي ==========
  estimatedValue: "القيمة المقدرة",
  buyPoints: "شراء نقاط",
  withdraw: "سحب",
  minimumWithdrawal: "الحد الأدنى للسحب هو 1000 نقطة ($9.50)",
  profileManagement: "إدارة الملف الشخصي",
  editProfile: "تعديل الملف الشخصي",
  changePassword: "تغيير كلمة المرور",
  updateProfile: "تحديث الملف الشخصي",

  // ========== السحب ==========
  requestWithdrawal: "طلب سحب",
  pointsToWithdraw: "النقاط للسحب",
  paypalEmail: "بريد PayPal",
  youllReceive: "ستحصل على",
  platformFee: "رسوم المنصة",
  withdrawalInfo: "معلومات السحب",
  minimum: "الحد الأدنى",
  submitRequest: "إرسال الطلب",
  withdrawalMinimum: "الحد الأدنى: 1000 نقطة ($9.50)",
  withdrawalFee: "رسوم المنصة: 5%",
  withdrawalProcessing: "المعالجة: 24-96 ساعة",
  feePercent: "رسوم 5%",
  info: "معلومات",
  submitting: "جاري الإرسال...",
  submitting: "جارٍ الإرسال...",
  leaveEmptyToUse: "اتركه فارغاً لاستخدام بريد حسابك",
  withdrawalHistory: "سجل السحوبات",
  noWithdrawalRequests: "لا توجد طلبات سحب بعد.",
  note: "ملاحظة",

  // ========== إدارة الملف الشخصي ==========
  currentPassword: "كلمة المرور الحالية",
  newPassword: "كلمة المرور الجديدة",
  confirmNewPassword: "تأكيد كلمة المرور الجديدة",
  enterCurrentPassword: "أدخل كلمة مرورك الحالية",
  enterNewPassword: "أدخل كلمة مرور جديدة (6 أحرف كحد أدنى)",
  confirmYourNewPassword: "أكد كلمة مرورك الجديدة",
  passwordsMatch: "✓ كلمات المرور متطابقة",
  passwordsDoNotMatch: "✗ كلمات المرور غير متطابقة",
  securityTips: "نصائح الأمان",
  useAtLeast8Characters: "استخدم 8 أحرف على الأقل",
  includeUppercaseLowercase: "أضف أحرف كبيرة وصغيرة",
  addNumbersSpecialChars: "أضف أرقام ورموز خاصة",
  dontUsePersonalInfo: "لا تستخدم معلومات شخصية",
  changing: "جارٍ التغيير...",
  makesSureThisMatches: "⚠️ تأكد من تطابق هذا مع اسمك داخل اللعبة!",
  passwordStrength: "قوة كلمة المرور",
  weak: "ضعيف",
  medium: "متوسط",
  strong: "قوي",
  useUppercaseLowercase: "استخدم أحرف كبيرة وصغيرة وأرقام ورموز لكلمة مرور أقوى",
  testCurrentPassword: "اختبر كلمة المرور الحالية",

  // ========== سجل المباريات ==========
  yourMatchHistory: "سجل مبارياتك",
  noCompletedMatches: "لا توجد مباريات مكتملة بعد.",
  joinTournamentsHistory: "انضم للبطولات لبناء سجل مبارياتك!",
  entryFeeLabel: "الدخول",
  prizeLabel: "الجائزة",
  dateLabel: "التاريخ",
  match: "المباراة",
  mode: "الوضع",
  date: "التاريخ",
  pts: "نقاط",
  split: "تقسيم",
  ways: "طرق",
  loadingMatchHistory: "جارٍ تحميل سجل المباريات...",

  // ========== نظام صندوق الوارد ==========
  supportInbox: "صندوق الدعم",
  newReport: "تقرير جديد",
  submitNewSupportReport: "إرسال تقرير دعم جديد",
  subject: "الموضوع",
  description: "الوصف",
  submitReport: "إرسال التقرير",
  noCasesYet: "لا توجد حالات دعم بعد",
  createNewReport: "أنشئ تقريراً جديداً إذا كنت بحاجة مساعدة في البطولات أو المدفوعات أو مشاكل الحساب.",
  submitFirstReport: "أرسل أول تقرير لك",
  open: "مفتوح",
  closed: "مغلق",
  beforeSubmitting: "قبل الإرسال:",
  beAsDetailed: "• كن مفصلاً قدر الإمكان في وصفك",
  includeRelevantUsernames: "• أضف أي أسماء مستخدمين أو معرفات بطولات ذات صلة",
  supportTeamWillReview: "• سيراجع فريق الدعم ويرد خلال 24 ساعة",
  minimumCharactersRequired: "الحد الأدنى 5 أحرف",
  minimum10CharactersRequired: "الحد الأدنى 10 أحرف",
  submissionProcess: "عملية الإرسال:",
  reportWillBeSubmitted: "سيتم إرسال تقريرك كمغلق مبدئياً وسيراجعه فريق الدعم. بعد المراجعة، قد يعيدون فتحه للسماح بمزيد من التواصل إذا لزم الأمر.",
  typeYourMessage: "اكتب رسالتك...",
  sending: "جارٍ الإرسال...",
  send: "إرسال",
  pressEnterShift: "اضغط Enter + Shift لسطر جديد",
  caseNumber: "الحالة",
  updated: "محدث",
  messages: "رسائل",
  clickToView: "انقر لعرض المحادثة",
  thisCaseIsClosed: "هذه الحالة مغلقة. لا يمكنك الرد على الحالات المغلقة.",
  activeMatchDetails: "تفاصيل المباراة النشطة",
  matchSettings: "🏆 إعدادات المباراة",
  teamMembers: "👥 أعضاء الفريق",
  type: "النوع",

  // ========== ترجمات لوحة صندوق الوارد للإدارة ==========
  supportInboxManagement: "إدارة صندوق الدعم",
  createCase: "إنشاء حالة",
  totalCases: "إجمالي الحالات",
  openCases: "الحالات المفتوحة",
  closedCases: "الحالات المغلقة",
  allStatus: "جميع الحالات",
  allAssignments: "جميع التعيينات",
  unassigned: "غير معين",
  assignedToMe: "معين لي",
  loadingCases: "جارٍ تحميل الحالات...",
  noCasesFound: "لم يتم العثور على حالات",
  adjustFiltersOrCreateCase: "عدل الفلاتر أو أنشئ حالة جديدة لمستخدم",

  // الترجمات الأساسية الناقصة
  unknown: "غير معروف",
  mins: "د",
  hrs: "س",
  daysShort: "ي",
  ago: "منذ",
  warning: "تحذير",
  view: "عرض",
  viewCase: "عرض",
  created: "أُنشئ",
  createNewCaseForUser: "إنشاء حالة جديدة لمستخدم",
  selectUser: "اختر مستخدم",
  searchUsersUsername: "ابحث عن المستخدمين باسم المستخدم، البريد، أو الاسم داخل اللعبة...",
  selected: "المحدد:",
  initialMessage: "الرسالة الأولى",
  caseSubject: "موضوع الحالة...",
  initialMessageToUser: "الرسالة الأولى للمستخدم...",
  createCaseBtn: "إنشاء الحالة",
  closeCase: "إغلاق الحالة",
  openCase: "فتح الحالة",
  assignToMe: "تعيين لي",
  unassignCase: "إلغاء التعيين",
  deleteCase: "حذف الحالة",
  assignedTo: "معين لـ:",
  systemMessage: "النظام",
  typeYourResponse: "اكتب ردك...",
  deleteCaseModal: "حذف الحالة",
  deleteCaseWarning: "تحذير:",
  deleteCaseText: "هذا الإجراء لا يمكن التراجع عنه. سيتم حذف الحالة وجميع رسائلها نهائياً.",
  deleting: "جارٍ الحذف...",
  youAreCurrentlyViewing: "📝 أنت تعرض هذه الحالة حالياً",
  youAreViewingCasesList: "📋 أنت تعرض قائمة الحالات",
  afterDeletionReturn: "بعد الحذف، ستعود إلى قائمة الحالات",
  listWillRefresh: "القائمة ستتحدث بعد الحذف",
  caseLabel: "الحالة:",
  userLabel: "المستخدم:",
  messagesLabel: "الرسائل:",
  newReportFrom: "تقرير جديد من {user}: {subject}",
  newMessageInCase: "رسالة جديدة في الحالة {caseNumber}",
  caseAssignedToYou: "الحالة {caseNumber} معينة لك",
  pleaseFillAllFields: "يرجى ملء جميع الحقول",
  caseCreatedSuccessfully: "تم إنشاء الحالة بنجاح",
  failedToCreateCase: "فشل في إنشاء الحالة",
  pleaseEnterMessage: "يرجى إدخال رسالة",
  failedToSendMessage: "فشل في إرسال الرسالة",
  caseStatusSuccessfully: "تم {status} الحالة بنجاح",
  failedToUpdateCaseStatus: "فشل في تحديث حالة القضية",
  caseAssignedSuccessfully: "تم تعيين الحالة بنجاح",
  caseUnassignedSuccessfully: "تم إلغاء تعيين الحالة بنجاح",
  failedToAssignCase: "فشل في تعيين الحالة",
  caseDeletedSuccessfully: "تم حذف الحالة بنجاح",
  failedToDeleteCase: "فشل في حذف الحالة",
  noCaseSelectedForDeletion: "لم يتم اختيار حالة للحذف",
  noCaseSelected: "لم يتم اختيار حالة",
  reasonForClosing: "سبب إغلاق هذه الحالة:",
  reasonForOpening: "سبب فتح هذه الحالة:",
  closing: "إغلاق",
  opening: "فتح",
  assignment: "التعيين",
  status: "الحالة",
  user: "المستخدم",
  createdLabel: "أُنشئ",
  updatedLabel: "حُدث",
  emptyStateTitle: "لم يتم العثور على حالات",
  emptyStateText: "عدل الفلاتر أو أنشئ حالة جديدة لمستخدم",

  // ========== رسائل خطأ صندوق الوارد ==========
  failedToLoadInbox: "فشل في تحميل صندوق الوارد",
  failedToLoadCase: "فشل في تحميل الحالة",
  pleaseFillBothFields: "يرجى ملء كل من الموضوع والوصف",
  subjectMinLength: "الموضوع يجب أن يكون 5 أحرف على الأقل",
  descriptionMinLength: "الوصف يجب أن يكون 10 أحرف على الأقل",
  reportSubmittedSuccessfully: "تم إرسال التقرير بنجاح",
  failedToSubmitReport: "فشل في إرسال التقرير",
  messageTooLong: "الرسالة طويلة جداً (الحد الأقصى 1000 حرف)",
  briefDescriptionPlaceholder: "وصف موجز لمشكلتك...",
  detailedDescriptionPlaceholder: "يرجى تقديم معلومات تفصيلية عن مشكلتك، بما في ذلك أي أسماء مستخدمين ذات صلة أو معرفات بطولات أو خطوات إعادة إنتاج المشكلة...",
  hasBeenLabel: "قد تم",
  reopened: "إعادة فتح",
  yourCase: "حالتك",
  hasBeenDeleted: "قد تم حذفها بواسطة",

  // ========== نظام الدفع ==========
  buyTournamentPoints: "شراء نقاط البطولة",
  chooseYourPerfectPackage: "اختر حزمتك المثالية وابدأ التنافس!",
  selectYourPackage: "اختر حزمتك",
  chooseTheAmountOfPoints: "اختر كمية النقاط التي تناسب احتياجاتك في اللعب",
  instantDelivery: "توصيل فوري",
  securePayment: "دفع آمن",
  noExpiration: "لا انتهاء صلاحية",
  securePaymentInfo: "معلومات الدفع الآمن",
  processingPayment: "جارٍ معالجة الدفع...",
  yourPaymentProcessedSecurely: "يتم معالجة دفعتك بأمان بواسطة PayPal",
  pointsAddedInstantly: "النقاط تُضاف لحسابك فوراً",
  allTransactionsEncrypted: "جميع المعاملات مشفرة وآمنة",
  noHiddenFeesOrCharges: "لا توجد رسوم أو تكاليف خفية",
  pointsPerDollar: "نقاط لكل $",

  // ========== أوصاف حزم الدفع ==========
  perfectForTryingOut: "مثالي للتجربة",
  bestValueForBeginners: "أفضل قيمة للمبتدئين",
  seriousPlayersChoice: "اختيار اللاعبين الجادين",
  tournamentReady: "جاهز للبطولات",
  competitiveEdge: "ميزة تنافسية",
  proTournamentBundle: "حزمة البطولات الاحترافية",
  maximumValuePack: "حزمة القيمة القصوى",

  // ========== شارات الحزم ==========
  starter: "بداية",
  basic: "أساسي",
  mostPopular: "الأكثر شعبية",
  greatValue: "قيمة رائعة",
  powerPack: "حزمة القوة",
  ultimate: "النهائي",
  megaPack: "حزمة ضخمة",

  // ========== تعليمات الشراء ==========
  howToPurchase: "كيفية الشراء",
  selectPackage: "اختر الحزمة",
  chooseYourPreferredPackage: "اختر حزمة النقاط المفضلة لديك أعلاه",
  clickPayPal: "انقر PayPal",
  proceedWithSecureCheckout: "تابع مع الدفع الآمن عبر PayPal",
  completePayment: "أكمل الدفع",
  finishTransactionViaPayPal: "أنهِ المعاملة عبر PayPal",
  pointsAddedImmediatelyToAccount: "النقاط تُضاف فوراً لحسابك",

  // ========== أوضاع البطولة ==========
  snipersOnly: "قناصة فقط",
  rifleOnly: "بنادق فقط",
  knifeOnly: "سكاكين فقط",
  executionOnly: "إعدام فقط",
  grenadesOnly: "متفجرات فقط",
  snipers: "قناصة",
  rifles: "بنادق",
  melee: "سلاح أبيض",
  execution: "إعدام",
  explosives: "متفجرات",
  custom: "مخصص",
  ffa: "الكل ضد الكل",

  // ========== أوضاع اللعب ==========
  teamDeathmatch: "⚔️ ديث ماتش فريق",
  domination: "🏁 السيطرة",
  searchAndDestroy: "💣 بحث وتدمير",
  hardpoint: "📍 هاردبوينت",
  killConfirmed: "🏷️ تأكيد القتل",
  captureTheFlag: "🚩 اقتناص العلم",
  frontline: "⚡ فرونت لاين",
  freeForAll: "🎯 الكل ضد الكل",
  gunGame: "🔫 لعبة الأسلحة",
  sticksAndStones: "عصي وحجارة",
  oneShotOneKill: "🎯 طلقة واحدة قتلة واحدة",
  cranked: "⚡ كرانكد",
  rapidFire: "💨 نار سريعة",
  attackOfTheUndead: "🧟 هجوم الموتى",

  // ========== التسميات العامة ==========
  tournament: "البطولة",
  random: "عشوائي",

  // ========== الخرائط ==========
  randomMap: "🎲 خريطة عشوائية",

  // ========== نافذة كلمة المرور ==========
  passwordProtectedTournament: "🔒 بطولة محمية بكلمة مرور 🔒",
  tournamentPasswordProtected: "هذه البطولة محمية بكلمة مرور. تحتاج كلمة المرور الصحيحة للانضمام.",
  enterPassword: "أدخل كلمة المرور",

  // ========== نافذة الحظر ==========
  accountBanned: "🚫 الحساب محظور 🚫",
  accountBannedDesc: "حسابك محظور ولا يمكنه تسجيل الدخول.",
  bannedBy: "محظور بواسطة",
  contactSupport: "تواصل مع الدعم إذا كنت تعتقد أن هذا خطأ.",
  understood: "فهمت",

  // ========== التحقق من النماذج ==========
  fieldRequired: "هذا الحقل مطلوب",
  invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
  passwordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
  usernameMinLength: "اسم المستخدم يجب أن يكون 3 أحرف على الأقل",
  usernameMaxLength: "اسم المستخدم يجب أن يكون أقل من 20 حرف",
  invalidCharacters: "يحتوي على أحرف غير صالحة",
  fieldTooLong: "هذا الحقل طويل جداً",
  fieldTooShort: "هذا الحقل قصير جداً",
  numberRequired: "يرجى إدخال رقم صالح",
  numberTooLow: "الرقم منخفض جداً",
  numberTooHigh: "الرقم مرتفع جداً",

  // ========== الأخطاء والرسائل العامة ==========
  error: "خطأ",
  success: "نجاح",
  info: "معلومات",
  failed: "فشل",
  retry: "إعادة المحاولة",
  confirm: "تأكيد",

  // ========== الإجراءات العامة ==========
  save: "حفظ",
  delete: "حذف",
  update: "تحديث",
  submit: "إرسال",
  reject: "رفض",

  // ========== ترجمات الإدارة الناقصة ==========
  banUser: "حظر المستخدم",
  unbanUser: "إلغاء حظر المستخدم",
  removeApprover: "إزالة المصادق",
  failedToApproveMatch: "فشل في الموافقة على المباراة",
  failedToCompleteMatch: "فشل في إكمال المباراة",
  startsIn: "يبدأ في",

  // ========== الوقت والتواريخ ==========
  now: "الآن",
  today: "اليوم",
  yesterday: "أمس",
  timeUntilAutoCancel: "دقيقة حتى الإلغاء التلقائي",
  timeRemaining: "دقيقة متبقية",

  // ========== الإشعارات ==========
  tournamentCreated: "تم إنشاء البطولة بنجاح!",
  joinedTournament: "انضممت للبطولة بنجاح!",
  leftTournament: "غادرت البطولة بنجاح!",
  profileUpdated: "تم تحديث الملف الشخصي بنجاح!",
  passwordChanged: "تم تغيير كلمة المرور بنجاح!",
  connectionRestored: "تم استعادة اتصال الخادم",
  reconnecting: "جارٍ إعادة الاتصال بالخادم...",
  tournamentApproved: "تم الموافقة على البطولة بواسطة",
  tournamentCompleted: "تم إكمال البطولة بواسطة",
  tournamentCancelled: "تم إلغاء البطولة بواسطة",
  tournamentAutoCancelled: "تم إلغاء البطولة تلقائياً: {tournamentName}",
  createdGiveawayTournament: "أنشأ بطولة هدايا في اللوبي!",
  createdNewMatch: "أنشأ مباراة جديدة في اللوبي!",
  isNowOnline: "متصل الآن!",
  commissionDistributed: "تم توزيع العمولة!",
  commissionUpdated: "تم تحديث إعدادات العمولة!",

  // ========== سلاسل إضافية ==========
  participants: "المشاركون",
  insufficientPointsDetailed: "نقاط غير كافية! تحتاج {needed} نقطة لكن لديك {current} نقطة فقط.",
  giveawayExplanation: "في بطولات الهدايا، تدفع {prize} نقاط (جائزة) + {commission} نقاط (عمولة) = {total} إجمالي",
  disobeyingWeaponRules: "⚠️ عدم اتباع قواعد الأسلحة سيؤدي إلى خسارة النقاط فوراً!",
  estimatedPrizePoolCalculation: "الجوائز المقدرة",
  baseCommission: "🏛️ العمولة الأساسية",
  highKillBonus: "⚡ مكافأة القتل العالي",
  totalCommission: "📊 إجمالي العمولة",
  extraCommissionFromHighKills: "عمولة إضافية {rate}% من عدد القتل العالي تذهب للمصادق.",
  failedToLoadTournaments: "فشل في تحميل البطولات",
  system: "النظام",

  // ========== خاص ببطاقة البطولة ==========
  participantsCount: "{current}/{max}",
  prizeFormat: "🏆{amount}",
  entryFormat: "💰{amount}",
  killsFormat: "💀{amount}K",
  modeFormat: "⚔️{mode}",
  mapFormat: "📍{map}",
  teamFormat: "👥{count}",
  timeFormat: "⏰{time}",
  dateFormat: "📅{date}",

  // ========== تحذيرات وقت الانتظار ==========
  warningAutoCancel: "⚠️ {time} دقيقة حتى الإلغاء التلقائي",
  warningTimeRemaining: "⏰ {time} دقيقة متبقية",

  // ========== المباراة النشطة ==========
  gameSettings: "إعدادات اللعبة",
  prizePool: "الجوائز",

  // ========== البطولات المنتهية ==========
  autoCancel: "ملغي تلقائياً",
  canceled: "ملغي",
  cancelledBy: "ملغي بواسطة",
  more: "المزيد",
  approvedBy: "موافق بواسطة",

  // ========== إصلاحات البطولة ==========
  failedToCreateTournament: "فشل في إنشاء البطولة",
  matchType: "نوع المباراة",

  // ========== التصويت للبدء المبكر ==========
  voteToStart: "صوت للبدء",
  earlyStartVoting: "تصويت البدء المبكر",
  voteForEarlyStart: "صوت للبدء المبكر",
  removeVote: "إزالة التصويت",
  votesNeeded: "الأصوات المطلوبة",
  allPlayersVoted: "جميع اللاعبين صوتوا!",
  waitingForVotes: "في انتظار الأصوات...",
  prizeWillChange: "⚠️ الجائزة ستتغير لأن اللوبي غير ممتلئ",
  currentPrize: "الجائزة الحالية",
  newPrize: "الجائزة الجديدة",
  youVoted: "✓ صوتّ",
  voteRegistered: "تم تسجيل تصويتك!",
  voteRemoved: "تم إزالة تصويتك",
  failedToVote: "فشل في تسجيل التصويت",

  // ========== تحكم الهدايا ==========
  instantStart: "بدء فوري",
  requestVote: "طلب تصويت",
  giveawayCreatorControls: "تحكم منشئ الهدايا",
  startInstantly: "بدء فوري",
  initiateVote: "بدء تصويت",

  // ========== بطولة متعددة المراحل ==========
  multistepTournaments: "بطولات متعددة المراحل",
  multistepTournament: "بطولة متعددة المراحل",
  createBracketTournament: "إنشاء بطولة متعددة المراحل",
  createBracket: "إنشاء",
  noBracketTournaments: "لا توجد بطولات متعددة المراحل حتى الآن",
  bracketTournamentCreated: "تم إنشاء البطولة متعددة المراحل!",
  numberOfTeams: "عدد الفرق",
  costSummary: "ملخص التكلفة",
  prizePerWinner: "الجائزة لكل فائز",
  confirmCreate: "تأكيد إنشاء البطولة",
  viewBracket: "الأقواس",
  tournamentBracket: "أقواس البطولة",
  joinedTeam: "انضممت للفريق بنجاح!",
  tournamentStarted: "بدأت البطولة!",
  confirmWinner: "تعيين هذا الفريق كفائز؟",
  yourTeam: "فريقك",
  registration: "التسجيل",
  final: "النهائي",
  semiFinals: "نصف النهائي",
  quarterFinals: "ربع النهائي",
  round: "جولة",
  matches: "مباريات",
  tbd: "يحدد لاحقاً",
  clickToSelectWinner: "انقر على الفريق لاختيار الفائز",
  perWinner: "لكل فائز",
  tournamentWinners: "فائزو البطولة",
  full: "ممتلئ",
  showTeams: "عرض الفرق",
  hideTeams: "إخفاء الفرق",
  startTournament: "بدء",
  viewAllTeams: "جميع الفرق والمباريات",
  allTeamsMatchups: "جميع الفرق والمباريات",
  teams: "الفرق",
  activeBracketMatches: "مباريات الأقواس النشطة",
  configureMatch: "إعداد المباراة",
  configureMatchups: "إعداد المباريات",
  startMatch: "بدء المباراة",
  applications: "الطلبات",
  pendingTeams: "فرق قيد الانتظار",
  approvedTeams: "فرق معتمدة",
  pendingApplications: "طلبات قيد الانتظار",
  noApplications: "لا توجد طلبات قيد الانتظار",
  noApprovedTeamsYet: "لا توجد فرق معتمدة حتى الآن",
  pendingTeamsApproval: "فرق بانتظار الموافقة",
  pendingTeamsInfo: "هذه الفرق تنتظر الموافقة",
  approveTeam: "موافقة",
  rejectTeam: "رفض",
  teamApproved: "تمت الموافقة على الفريق!",
  teamRejected: "تم رفض الفريق وإزالته",
  applicationApproved: "تمت الموافقة على الطلب!",
  applicationRejected: "تم رفض الطلب",
  errorApprovingTeam: "خطأ في الموافقة على الفريق",
  errorRejectingTeam: "خطأ في رفض الفريق",
  errorApproving: "خطأ في الموافقة على الطلب",
  errorRejecting: "خطأ في رفض الطلب",
  applyToTournament: "تقديم طلب للبطولة",
  applyToJoin: "تقديم طلب للانضمام",
  applyToTeam: "تقديم طلب",
  applying: "جارٍ التقديم...",
  applied: "تم التقديم",
  teamApplied: "تم تقديم طلب الفريق! في انتظار موافقة المسؤول.",
  applicationSubmitted: "تم تقديم الطلب! في انتظار موافقة المسؤول.",
  applicationPending: "طلبك لـ",
  isPending: "قيد الانتظار للموافقة",
  awaitingApproval: "في انتظار الموافقة",
  createNewTeam: "إنشاء فريق جديد",
  youAreCaptain: "أنت قائد الفريق!",
  captainInfo: "كقائد الفريق، يمكنك تعيين تفضيلات لمن يمكنه الانضمام إلى فريقك.",
  teamPreferences: "تفضيلات الفريق",
  setPreferencesFirst: "اختر الفريق أولاً",
  captain: "القائد",
  teamName: "اسم الفريق",
  enterTeamName: "أدخل اسم الفريق",
  teammates: "زملاء الفريق",
  teammate: "زميل الفريق",
  teammatesHint: "أدخل أسماء المستخدمين لـ 4 زملاء فريقك",
  teammatesUpdated: "تم تحديث أسماء زملاء الفريق!",
  editTeammates: "تعديل أسماء زملاء الفريق",
  editTeammateNames: "تعديل أسماء زملاء الفريق",
  editNames: "تعديل الأسماء",
  editHint: "حدّث أسماء المستخدمين لزملاء فريقك",
  saveChanges: "حفظ التغييرات",
  saving: "جارٍ الحفظ...",
  need4Teammates: "يجب تحديد جميع زملاء الفريق الـ 4",
  needMoreTeammates: "تحتاج المزيد من أسماء زملاء الفريق",
  duplicateNames: "أسماء زملاء الفريق يجب أن تكون فريدة",
  dontIncludeYourself: "لا تضف نفسك في قائمة زملاء الفريق",
  errorCreatingTeam: "خطأ في إنشاء الفريق",
  yourAllowedSquadmates: "زملاء فريقك المسموح بهم",
  noSquadmatesSet: "لم يتم تعيين زملاء الفريق - يمكن لأي شخص الانضمام إلى فريقك",
  edit: "تعديل",
  save: "حفظ",
  saving: "جاري الحفظ...",
  errorUpdating: "خطأ في تحديث زملاء الفريق",
  joinThisTeam: "انضم للفريق",
  joinYourTeam: "انضم لفريقك",
  leaveTeam: "مغادرة الفريق",
  confirmLeave: "هل أنت متأكد أنك تريد المغادرة؟",
  errorJoining: "خطأ في الانضمام للفريق",
  errorLeaving: "خطأ في المغادرة",
  kickPlayer: "إزالة اللاعب",
  kickTeam: "طرد/استبعاد الفريق",
  playerKicked: "تمت إزالة اللاعب من الفريق",
  teamKicked: "تم طرد الفريق",
  confirmKick: "إزالة هذا اللاعب من فريقك؟",
  enterKickReason: "أدخل سبب طرد/استبعاد هذا الفريق:",
  errorKicking: "خطأ في إزالة اللاعب",
  errorKickingTeam: "خطأ في طرد الفريق",
  invited: "مدعوون",
  inviteOnly: "دعوة فقط",
  yourNameInvited: "يجب أن يكون اسمك في قائمة المدعوين للانضمام",
  waiting: "انتظار",
  waitingToJoin: "بانتظار الانضمام",
  captain: "القائد",
  totalSlots: "إجمالي الخانات",
  alreadyJoined: "انضممت بالفعل",
  allTeamsTaken: "جميع الفرق محجوزة",
  teamsReady: "فرق جاهزة",
  teamsWaitingForYou: "فرق تنتظرك",
  applyHint: "قدم طلباً للانضمام لفريق موجود أو أنشئ فريقك",
  applyHintAdmin: "أنشئ فرقاً وقم بإعداد المباريات",
  createHintFull: "جميع خانات الفرق ممتلئة",
  enterRoomId: "أدخل معرف الغرفة",
  customMap: "خريطة مخصصة",
  enterCustomMapName: "أدخل اسم الخريطة المخصصة",
  matchStarted: "بدأت المباراة!",
  errorStartingMatch: "خطأ في بدء المباراة",
  confirmStart: "بدء البطولة؟ سيتم قفل الفرق.",
  errorStarting: "خطأ في بدء البطولة",
  selectWinner: "اختر الفائز",
  errorSettingWinner: "خطأ في تعيين الفائز",
  cancelReason: "سبب الإلغاء:",
  errorCancelling: "خطأ في الإلغاء",
  firstRoundMatchups: "مباريات الجولة الأولى",
  matchupHint: "حدد أي الفرق تواجه بعضها",
  saveMatchups: "حفظ المباريات",
  selectBothTeams: "يرجى اختيار كلا الفريقين لجميع المباريات",
  duplicateTeam: "كل فريق يمكن استخدامه مرة واحدة فقط",
  matchupsConfigured: "تم إعداد المباريات بنجاح!",
  errorConfiguringMatchups: "خطأ في إعداد المباريات",
  adjustSizeTo: "تعديل إلى",
  confirmAdjustSize: "تعديل حجم الأقواس؟ سيعيد هذا بناء هيكل الأقواس.",
  bracketAdjusted: "تم تعديل الأقواس",
  errorAdjustingSize: "خطأ في تعديل حجم الأقواس",
  allTeamsApproved: "تمت الموافقة على جميع الفرق",
  approveAllTeams: "الموافقة على جميع الفرق",
  confirmApproveAll: "الموافقة على جميع الفرق المعلقة؟",
  reroll: "إعادة القرعة",
  rerollMatchup: "تبديل عشوائي",
  other: "آخر",
  otherMatchup: "اختر فريقاً للتبديل",
  selectTeamToSwap: "اختر فريقاً للتبديل معه:",
  teamSwapped: "تم تبديل الفريق!",
  errorSwappingTeam: "خطأ في تبديل الفريق",
  or: "أو",
  fillAllFields: "يرجى ملء جميع الحقول",
  required: "مطلوب",
  prizeSummary: "ملخص الجوائز",
  freeForAdmins: "مجاني للمسؤولين",
  gameModePerMatch: "يتم إعداد وضع اللعب والخريطة لكل مباراة على حدة",
  each: "لكل",
  starting: "جارٍ البدء...",
  pendingApproval: "قيد الانتظار",

  // ========== VOTE TO START EARLY ==========
  voteEarlyStart: "صوت للبدء المبكر",
  voteToStart: "صوت للبدء المبكر",
  voteToStartEarly: "صوت لبدء البطولة مبكراً",
  voteRecorded: "تم تسجيل التصويت! ({current}/{total})",
  voteRemoved: "تم إزالة التصويت",
  voteRequestSent: "تم إرسال طلب التصويت لجميع المشاركين!",
  voteInProgress: "التصويت قيد التقدم ({current}/{total})",
  vote: "صوت",
  earlyPrize: "البدء المبكر",
  votesNeeded: "أصوات مطلوبة",
  votedPlayers: "اللاعبون الذين صوتوا",
  voteRequestSentWaiting: "تم إرسال طلب التصويت! بانتظار اللاعبين...",
  voteNote: "ستبدأ البطولة تلقائياً عندما يصوت جميع اللاعبين الحقيقيين.",
  voteNoteGiveaway: "في مباريات الهبات، يجب على المنشئ بدء المباراة يدوياً بعد استلام جميع الأصوات.",

  // ========== CREATE TOURNAMENT TEAM PREFERENCE ==========
  teamPreference: "تفضيل الفريق",
  randomAnyPlayerCanJoin: "عشوائي - يمكن لأي لاعب الانضمام لفريقك",
  specificChooseTeammates: "محدد - اختر زميل(زملاء) فريقك",
  emptySlotOptional: "خانة فارغة (اختياري)",
  enterPlayerInGameName: "أدخل اسم اللاعب في اللعبة",

  // ========== BR EDIT TEAM ==========
  editTeam: "تعديل الفريق",
  viewTeam: "عرض الفريق",
  viewPlayers: "عرض اللاعبين",
  viewTeamPositions: "مواقع الفرق",
  editAllowedTeammates: "تعديل زملاء الفريق المسموح بهم",
  teammatesHint: "أدخل أسماء اللاعبين المسموح لهم بالانضمام إلى فريقك. اتركه فارغاً أو اضبطه عشوائياً للسماح لأي شخص.",
  mpTeammatesHint: "أدخل أسماء اللاعبين للسماح للاعبين محددين. استخدم 🎲 للاعبين العشوائيين. الخانات الفارغة مقفلة.",
  specificPreference: "الوضع المحدد - فقط اللاعبون المسمون يمكنهم الانضمام",
  captain: "قائد",
  specific: "محدد",
  lockedSlot: "خانة مقفلة",
  lockedSlotInfo: "🔒 مقفل - لا يمكن لأحد الانضمام",
  openSlot: "خانة مفتوحة",
  waitingFor: "في انتظار",
  unlockSlot: "فتح الخانة (السماح بالعشوائي)",
  lockSlot: "قفل الخانة",

  // ========== KICK PLAYER MODAL ==========
  kickPlayerTitle: "إزالة اللاعب",
  kickPlayerConfirm: "هل أنت متأكد من إزالة هذا اللاعب؟",
  kickFillerConfirm: "إزالة هذا الملء من البطولة؟",
  removeFromTournament: "إزالة من البطولة",
  kickReason: "السبب (اختياري)",

  // ========== MP TEAM SELECTION ==========
  teamSelection: "اختيار الفريق",
  selectTeam: "اختر فريقك",
  mpTeamSelectInfo: "اختر الفريق للانضمام في هذه المباراة",
  youWillBeCaptain: "ستكون قائد الفريق",
  youAreInvited: "أنت مدعو لهذا الفريق",
  joiningViaRandomSlot: "الانضمام عبر خانة عشوائية",
  teamNotAccepting: "هذا الفريق لا يقبل لاعبين",
  squadOnly: "الفريق فقط",
  spotsAvailable: "أماكن متاحة",
  captainSettings: "إعدادات قائد الفريق",
  captainSettingsInfo: "كقائد الفريق، اختر من يمكنه الانضمام لفريقك",
  teamJoinMode: "وضع الانضمام للفريق",
  randomTeammate: "🎲 عشوائي - يمكن لأي لاعب الانضمام لفريقك",
  specificTeammate: "👥 محدد - اختر زميل(زملاء) فريقك",
  slot: "خانة",
  clickToEmpty: "انقر لترك فارغ",
  clickForRandom: "انقر للعشوائي",
  random: "عشوائي",
  setRandom: "تعيين عشوائي",
  anyPlayerCanJoin: "يمكن لأي لاعب الانضمام لهذه الخانة",
  teammatesNote: "اترك الخانات فارغة لمنع الآخرين من الانضمام لفريقك",
  joining: "جارٍ الانضمام...",
  createTeam: "إنشاء فريق",
  joinTeam: "انضم للفريق",
  editTeamPreferences: "تعديل تفضيلات الفريق",
  viewAllTeamPositions: "عرض جميع مواقع الفرق",
  emptySlot: "خانة فارغة",
  enterPlayerInGameName: "أدخل اسم اللاعب في اللعبة",
  enterNameOrSetRandom: "أدخل الاسم أو اختر عشوائي",
  enterExactInGameName: "أدخل الاسم الدقيق لزميلك في اللعبة، أو اختر عشوائي",
  editAllowedSquadmates: "تعديل أعضاء الفريق المسموح بهم",
  squadPreference: "وضع الفريق - أعضاء محددون فقط",
  randomPreference: "وضع عشوائي - يمكن لأي شخص الانضمام",
  squadmatesHint: "أدخل أسماء اللاعبين المسموح لهم بالانضمام لفريقك. اتركه فارغاً أو اختر عشوائي للسماح لأي شخص.",
  slot: "خانة",
  anyoneCanJoin: "يمكن لأي شخص الانضمام لهذه الخانة",
  emptySlotInfo: "فارغ - لا يمكن لأحد استخدام هذه الخانة",
  specificPlayer: "فقط هذا اللاعب يمكنه الانضمام",
  clearSlot: "مسح الخانة",
  randomPlayer: "لاعب عشوائي",
  enterPlayerName: "أدخل اسم اللاعب...",
  playerName: "اسم اللاعب",
  saveChanges: "حفظ التغييرات",
  saving: "جارٍ الحفظ...",

  // ========== VOTE EARLY START MODAL ==========
  prizeReductionWarning: "تحذير تخفيض الجائزة",
  lobbyNotFull: "اللوبي غير ممتلئ ({current}/{max} لاعبين)",
  current: "الحالي",

  // ========== KICK PLAYER MODAL EXTRAS ==========
  kick: "طرد",
  realPlayer: "لاعب حقيقي",
  fillerPlayer: "لاعب ملء",
  fillerBot: "بوت ملء",
  playerWillReceiveRefund: "سيحصل اللاعب على استرداد {amount} نقطة",
  thisActionIsPermanent: "هذا الإجراء دائم",
  playerWillBeRemoved: "سيتم إزالة هذا اللاعب من البطولة ولن يتمكن من الانضمام مجدداً.",
  tournamentInformation: "معلومات البطولة",
  currentPlayers: "الحالي: {current}/{max} لاعبين",
  kickParticipant: "طرد {type}",
  player: "لاعب",
  filler: "ملء",
  yourFiller: "الملء الخاص بك",
  youAddedThis: "لقد أضفت هذا الملء",
  othersFiller: "ملء شخص آخر",
  addedBySomeoneElse: "أضافه لاعب آخر",
  refundInformation: "معلومات الاسترداد",
  playerRefund: "سيحصل اللاعب على استرداد {amount} نقطة",
  fillerRefund: "سيحصل مالك الملء على استرداد {amount} نقطة",
  fillerRefundNote: "الاسترداد يذهب للشخص الذي أضاف الملء",
  permanentAction: "هذا الإجراء دائم",
  playerKickWarning: "سيتم إزالة هذا اللاعب من البطولة ولن يتمكن من الانضمام مجدداً.",
  fillerKickWarning: "سيتم إزالة هذا الملء من البطولة ولا يمكن إعادة إضافته.",
  tournamentInfo: "معلومات البطولة",
  currentParticipants: "الحالي: {current}/{max} لاعبين",
  currentFillers: "الملء: {count}",
  kicking: "جارٍ الطرد...",
  confirmKick: "طرد {type}",
  // Subscription translations
  weeklyPointDeals: "عروض النقاط الأسبوعية",
  subscriptionDescription: "احصل على 50٪ من النقاط فوراً + 50٪ يومياً لمدة 7 أيام",
  activePlan: "نشط",
  dayProgress: "اليوم",
  pointsReceived: "نقاط مستلمة",
  alreadyActive: "نشط بالفعل",
  selectPlan: "اختر الخطة",
  totalPoints: "إجمالي النقاط",
  instant: "فوري",
  perDay: "/يوم",
  days: "أيام",
  ptsPerDollar: "نقطة لكل $1",
  perWeek: "/أسبوع",
  processingSubscription: "جاري معالجة اشتراكك...",
  tierBasic: "أساسي",
  tierStandard: "قياسي",
  tierPlus: "بلس",
  tierPremium: "مميز",
  tierMax: "ماكس",
  // Vendor System
  vendorPackages: "باقات الموردين",
  vendorPackagesDescription: "شراء الباقات من شركائنا الموردين",
  currentRate: "السعر الحالي",
  selectedPackage: "الباقة المختارة",
  purchasePackage: "شراء الباقة",
  vendorNote: "سيقوم المورد بمعالجة طلبك وتوفير الباقة.",
  purchaseHistory: "سجل المشتريات",
  noPurchasesYet: "لا توجد مشتريات بعد",
  awaitingVendor: "في انتظار معالجة المورد",
  vendorRedeemed: "قام المورد بمعالجة طلبك",
  pointsRefunded: "تم استرداد النقاط",
  packagePurchased: "تم شراء الباقة بنجاح!",
  purchaseFailed: "فشل شراء الباقة",
  dashboard: "لوحة التحكم",
  refresh: "تحديث",
  pending: "قيد الانتظار",
  redeemed: "تم الاسترداد",
  confirmed: "مؤكد",
  cancelled: "ملغي",
  totalValue: "القيمة الإجمالية",
  all: "الكل",
  searchCoupons: "البحث عن القسائم...",
  noCouponsFound: "لم يتم العثور على قسائم",
  redeem: "استرداد",
  cancel: "إلغاء",
  delete: "حذف",
  waitingAdminConfirmation: "في انتظار تأكيد المسؤول",
  cancelCoupon: "إلغاء القسيمة",
  cancelWarning: "سيتم إرجاع جميع النقاط للمستخدم. لا يمكن التراجع.",
  user: "المستخدم",
  package: "الباقة",
  refundAmount: "مبلغ الاسترداد",
  typeCancel: "اكتب Cancel للتأكيد",
  back: "رجوع",
  confirmCancel: "تأكيد الإلغاء",
  couponRedeemed: "تم استرداد القسيمة بنجاح",
  couponCancelled: "تم إلغاء القسيمة واسترداد النقاط",
  couponDeleted: "تم حذف القسيمة",
  vendorCoupons: "قسائم الموردين",
  owed: "مستحق",
  paid: "مدفوع",
  redeemed: "تم الاسترداد",
  pts: "نقاط",
  upToTwoWeeks: "حتى أسبوعين",
  upToAWeek: "حتى أسبوع",
  minutesTo24Hours: "دقائق إلى 24 ساعة",
  specialUpTo3Hours: "خاص حتى 3 ساعات",
  upTo48Hours: "حتى 48 ساعة",
  confirmPurchase: "تأكيد الشراء",
  confirmPurchaseText: "هل أنت متأكد أنك تريد شراء هذه الباقة؟",
  yesPurchase: "نعم، اشتري",
  confirmRedeem: "تأكيد الاسترداد",
  redeemConfirmText: "هل أنت متأكد أنك تريد تحديد هذه القسيمة على أنها مستردة؟",
  yesRedeem: "نعم، استرد",
  no: "لا",
  couponCode: "رمز القسيمة",
  awaitingConfirmation: "في انتظار تأكيد الدفع",
  confirmPayment: "تأكيد الدفع",
  confirming: "جاري التأكيد...",
  couponConfirmed: "تم تأكيد القسيمة بنجاح",
  vendorILSRate: "سعر الشيكل للموردين",
  ilsRateDescription: "سعر الصرف لتسعير باقات الموردين (شيكل إلى دولار)",
  ilsToUsdRate: "1 دولار = ? شيكل",
  updateILSRate: "تحديث سعر الشيكل",
  ilsRateUpdated: "تم تحديث سعر الشيكل بنجاح",
  speedos: "سبيدوس",
  ryder: "رايدر",  chooseWithdrawMethod: 'اختر طريقة السحب',  selectHowToWithdraw: 'اختر كيف تريد سحب نقاطك',  withdrawPaypal: 'السحب عبر PayPal',  withdrawPaypalDesc: 'تحويل مباشر إلى حساب PayPal - الحد الأدنى 1,000 نقطة',  speedosDesc: 'حزم CP والألعاب',  ryderDesc: 'حزم CP والألعاب',  backToOptions: 'العودة للخيارات',  packages: 'الحزم',  contactVendor: 'تواصل',  contactOnTelegram: 'تواصل على تيليجرام',  afterPurchaseContact: 'بعد الشراء، تواصل مع البائع على تيليجرام:',

  
  // ========== MP MULTISTEP & ADDITIONAL ==========
  mpMultistep: "متعدد اللاعبين متعدد المراحل",
  mpMultistepDesc: "بطولة متعددة اللاعبين قائمة على الفرق مع تقدم الأقواس. 5 لاعبين لكل فريق.",
  teamsCount: "4 أو 8 أو 16 فريق",
  bracketElimination: "نظام الإقصاء بالأقواس",
  gameModePerMatch: "وضع اللعب يحدد لكل مباراة",
  soloSquadModes: "أوضاع فردي، ثنائي أو فريق",
  roundsRange: "2-5 جولات",
  cumulativePoints: "نقاط تراكمية من القتل + الترتيب",
  pts: "نق",
// ========== BR MULTISTEP TOURNAMENT ==========
  brMultistep: "باتل رويال متعدد المراحل",
  brMultistepDesc: "بطولة باتل رويال مع جولات متعددة",
  br_multistep: "باتل رويال متعدد المراحل",
  createBRMultistep: "إنشاء بطولة باتل رويال متعددة المراحل",
  brMultistepCreated: "تم إنشاء بطولة باتل رويال متعددة المراحل بنجاح",
  solo: "فردي",
  soloDesc: "لاعبون يتنافسون بشكل فردي",
  duo: "ثنائي",
  duoDesc: "فرق من لاعبين",
  squad: "فريق",
  squadDesc: "فرق من 4 لاعبين",
  controlMode: "وضع التحكم",
  control: "تحكم",
  manual: "يدوي",
  manualDesc: "المشرف يدير الغرف يدوياً",
  bot: "بوت",
  botDesc: "البوت ينشئ ويدير الغرف تلقائياً",
  botIdle: "البوت في انتظار",
  botCreatingRoom: "جاري إنشاء الغرفة...",
  botRoomReady: "الغرفة جاهزة",
  botWaitingPlayers: "في انتظار اللاعبين",
  botMatchActive: "المباراة جارية",
  botExtractingResults: "استخراج النتائج",
  botRoundComplete: "الجولة مكتملة",
  botError: "خطأ في البوت",
  botReconnected: "البوت أعاد الاتصال",
  numberOfRounds: "عدد الجولات",
  rounds: "جولات",
  scheduledStart: "موعد البدء المجدول",
  scheduledStartHint: "متى من المقرر أن تبدأ البطولة",
  pointsConfiguration: "إعدادات النقاط",
  pointsPerKill: "نقاط لكل قتل",
  perKill: "لكل قتل",
  placementPoints: "نقاط الترتيب",
  placementHint: "نقاط تُمنح بناءً على الترتيب النهائي",
  addPlacement: "إضافة ترتيب",
  place: "مركز",
  pointsDistribution: "توزيع النقاط",
  teams: "الفرق",
  allTeams: "جميع الفرق",
  noTeamsYet: "لا توجد فرق بعد",
  createNewTeam: "إنشاء فريق جديد",
  teamName: "اسم الفريق",
  enterTeamName: "أدخل اسم الفريق",
  teammates: "أعضاء الفريق",
  teammate: "عضو الفريق",
  enterTeammateNames: "أدخل أسماء أعضاء الفريق",
  enterAllTeammates: "أدخل جميع أسماء أعضاء الفريق",
  teamSize: "حجم الفريق",
  teamWillHave: "سيكون الفريق",
  youPlus: "أنت +",
  editTeam: "تعديل الفريق",
  editTeammatesHint: "تعديل أعضاء فريقك",
  editTeamNote: "يمكنك تعديل فريقك قبل بدء البطولة",
  teamUpdated: "تم تحديث الفريق بنجاح",
  viewTeams: "عرض الفرق",
  yourTeam: "فريقك",
  leader: "القائد",
  joinThisTeam: "انضم لهذا الفريق",
  joinMyTeam: "انضم لفريقي",
  joinMyTeamSelect: "اختر فريقاً للانضمام",
  joinWithTeam: "انضم مع فريق",
  selectYourTeam: "اختر فريقك",
  joinedTeam: "انضممت للفريق بنجاح",
  leaveTeam: "مغادرة الفريق",
  duplicateTeammate: "اسم عضو فريق مكرر",
  multipleTeamsInvited: "يمكن دعوة فرق متعددة",
  pendingSlots: "مقاعد شاغرة",
  manageRounds: "إدارة الجولات",
  matchSettings: "إعدادات المباراة",
  editSettings: "تعديل الإعدادات",
  saveSettings: "حفظ الإعدادات",
  saveChanges: "حفظ التغييرات",
  settingsSaved: "تم حفظ الإعدادات بنجاح",
  confirmCreate: "إنشاء البطولة؟",
  confirmStart: "بدء البطولة؟",
  confirmCancel: "إلغاء البطولة؟",
  confirmSwitchToManual: "التبديل للتحكم اليدوي؟",
  switchedToManual: "تم التبديل للتحكم اليدوي",
  roundStarting: "الجولة تبدأ",
  lobby: "اللوبي",
  inProgress: "جارية",
  completed: "مكتملة",
  cancelled: "ملغاة",
  startsAt: "تبدأ في",
  joining: "جاري الانضمام...",
  creating: "جاري الإنشاء...",
  saving: "جاري الحفظ...",
  joinTournament: "انضم للبطولة",
  joinedTournament: "انضممت للبطولة",
  leftTournament: "غادرت البطولة",
  tournamentStarted: "البطولة بدأت",
  tournamentCancelled: "البطولة ألغيت",
  tournamentSummary: "ملخص البطولة",
  errorCreating: "خطأ في إنشاء البطولة",
  failedToJoin: "فشل الانضمام للبطولة",
  failedToJoinTeam: "فشل الانضمام للفريق",
  failedToLeave: "فشلت المغادرة",
  failedToStart: "فشل البدء",
  failedToStartRound: "فشل بدء الجولة",
  failedToCancel: "فشل الإلغاء",
  failedToSaveSettings: "فشل حفظ الإعدادات",
  failedToUpdateTeam: "فشل تحديث الفريق",
  switchFailed: "فشل التبديل",
  commandFailed: "فشل الأمر",
  reconnectFailed: "فشل إعادة الاتصال",
  commandSent: "تم إرسال الأمر",
  maxPlayers: "الحد الأقصى للاعبين",
  leaveEmptyForPublic: "اتركه فارغاً للعام",
  optional: "اختياري",
  required: "مطلوب",
  freeForAdmins: "مجاني للمشرفين",
  minPlayersRequired: "الحد الأدنى للاعبين مطلوب",
  playersNotDivisible: "عدد اللاعبين لا يقبل القسمة على حجم الفريق",
  selectTournamentType: "اختر نوع البطولة",












};

export default arabicTranslations;
